// Extra strings for TurnosIA module and sidebar items not covered in es.js
const messages = {
  es: {
    translations: {
      // feat_315 — formato fecha/hora tipo WhatsApp (fmtSmartTimestamp)
      smartTimestamp: {
        yesterday: "Ayer",
        today: "Hoy",
      },
      loginPage: {
        sections: {
          waia: {
            nav: "WAIA",
            title: "Que atender por WhatsApp deje de comerte el día",
            chip1: "Bandeja compartida",
            chip2: "IA que responde",
            chip3: "Multiempresa",
          },
          turnosia: {
            nav: "TurnosIA",
            title: "Turnos por WhatsApp, sin ausencias",
            chip1: "Lista de espera IA",
            chip2: "Recordatorios",
            chip3: "Pantalla de sala",
          },
          integraciones: {
            nav: "Integraciones",
            title: "Conectá tus herramientas",
            chip1: "Google Sheets",
            chip2: "CRMs",
            chip3: "Webhooks · n8n",
            chip4: "API propia",
          },
        },
        metaBadge: "Proveedor de tecnología verificado — Meta",
      },
      turnosChat: {
        iaPaused: "IA pausada",
        keepAttending: "Seguir atendiendo",
        closeDialogTitle: "Cerrar chat de turnos",
        closeDialogBody: "¿Querés devolver la conversación a la IA o dejarla en atención humana?",
        returnToIa: "Sí, devolver a la IA",
        keepHuman: "Dejar en atención humana",
        continueAttending: "Seguir atendiendo",
        iaResumed: "La IA retomó la conversación",
        badgeActive: "TurnosIA",
        sessionError: "No se pudo gestionar la sesión de turnos",
      },
      floatingChat: {
        resize: "Redimensionar",
        minimize: "Minimizar",
        close: "Cerrar",
        openFloating: "Abrir en ventana flotante",
        errorOpening: "No se pudo abrir el chat",
        loadError: "No pudimos cargar esta conversación.",
        loadErrorDenied: "No tenés permiso para abrir este chat (el ticket no está en ninguna de tus colas).",
        retry: "Reintentar",
        loading: "Cargando conversación…",
        via: "vía",
        lineNotAllowed:
          "No se pudo abrir el chat en esa línea (no pertenece a tu empresa o no existe).",
      },
      templateOverrides: {
        loading: "Cargando plantillas…",
        sectionTitle: "Plantilla Meta por mensaje (fuera de las 24 h)",
        qrLine: "La línea de TurnosIA es QR (texto libre): no usa plantillas Meta.",
        noLine: "Esta empresa no tiene una línea Meta de TurnosIA configurada.",
        intro:
          "Elegí qué plantilla Meta aprobada usa cada mensaje fuera de la ventana de 24 h. Solo se ofrecen las compatibles en variables. Sin elección = la plantilla por convención.",
        vars: "variables",
        useDefault: "Usar la de convención",
        incompatible: "incompatible",
        backToDefault: "Volver al default",
        mapped: "Mapeada a",
        usingConvention: "Usa la convención",
        marketingWarning:
          "Es una plantilla MARKETING en un mensaje transaccional: Meta puede bloquearla o el cliente marcarla como spam.",
        noneCompatible:
          "No hay plantillas aprobadas compatibles (misma cantidad de variables) para este mensaje.",
        saveError: "No se pudo guardar el mapeo.",
        useLabel: "Fuera de las 24 h, usar:",
        metaSubsectionTitle: "Fuera de las 24 h (plantilla Meta)",
        notCreated: "todavía no está creada/aprobada en Meta",
        noPreview: "No hay vista previa para esta plantilla.",
        noMeta: "Este mensaje sale siempre como texto libre dentro de la conversación (sin plantilla Meta).",
        stApproved: "Aprobada",
        stPending: "En revisión",
        stRejected: "Rechazada",
        showExample: "Ver con datos de ejemplo",
        hideExample: "Ver con nombres de variable",
        reminderFuture: "Con anticipación (más de 12 h antes)",
        reminderToday: "El día del turno (12 h o menos)",
      },
      panel: {
        title: "Panel general",
        refresh: "Actualizar",
        summary: {
          messages2h: "Mensajes 2h",
          openTickets: "Tickets abiertos",
          activeCompanies: "Empresas activas",
          usersOnline: "Usuarios en línea",
          totalCompanies: "Empresas totales",
        },
        system: {
          disk: "Disco",
          mem: "Memoria",
          load: "Carga",
          public: "Media",
          uptime: "Uptime",
          error: "error al medir",
        },
        companies: "Empresas",
        search: "Buscar por nombre, slug, ID, usuario, email o notas…",
        filterAll: "Todas",
        col: {
          id: "ID",
          name: "Nombre",
          status: "Estado",
          usersOnline: "En línea",
          whatsapp: "WA",
          messages7d: "Msg 7d",
          actions: "Acciones",
        },
        actions: {
          edit: "Editar",
          impersonate: "Ver como",
          clear: "Limpiar datos",
          create: "Crear empresa",
          advanced: "Configuración avanzada",
          users: "Gestionar usuarios",
          viewAsAdmin: "Ver como admin",
          viewAsUser: "Ver como usuario específico",
        },
        notesLabel: "Notas (solo superadmin)",
        editTitle: "Editar empresa",
        createTitle: "Crear empresa",
        adminSection: "Usuario administrador inicial (opcional)",
        selfRegistration: "Permitir registro de empresas (signup público)",
        online: "En línea",
      },
      operationStatus: {
        active: "Activa",
        paused: "Pausada",
        blocked: "Bloqueada",
        waiting_meta: "Esperando Meta",
        demo: "Demo",
        trial: "Prueba",
      },
      aiAssistantStats: {
        menu: "Estadísticas IA",
        tooltips: {
          horasAhorradas:
            "Estimación del tiempo de atención que la IA le evitó al equipo. Se calcula a partir de la cantidad de conversaciones y un tiempo estimado de atención por conversación. Es un valor estimado, lo iremos afinando.",
          cobertura:
            "Porcentaje de respuestas que la IA dio fuera del horario de atención humana —de noche o fin de semana—, cuando una persona no habría respondido en el momento. Se mide sobre las conversaciones respondidas.",
          reclamosATiempo:
            "Cantidad de reclamos que la IA detectó y dejó marcados el mismo día, a tiempo para que el equipo pudiera actuar.",
          iaVsHumano:
            "Mensajes respondidos por la IA frente a los respondidos por una persona, en el período.",
          tasaRespuesta:
            "De las conversaciones que la IA inició, qué porcentaje contestó el cliente. Es respuestas dividido conversaciones enviadas.",
          tasaAccion:
            "De los clientes que respondieron, en qué porcentaje la IA llegó a una conclusión —conforme o reclamo—. Se mide sobre los que respondieron.",
          satisfechos:
            "Clientes que quedaron conformes. El primer porcentaje es sobre todas las conversaciones enviadas; el segundo, solo sobre las que respondieron.",
          reclamos:
            "Clientes que manifestaron un reclamo o disconformidad. El primer porcentaje es sobre el total enviado; el segundo, solo sobre los que respondieron.",
          sinRespuesta:
            "Clientes que no contestaron la encuesta. El primer porcentaje es sobre el total enviado; el segundo, sobre los que respondieron.",
          embudo:
            "Recorrido de las conversaciones: cuántas se enviaron, cuántas respondieron y cuántas llegaron a una conclusión.",
          primeraRespuesta:
            "Tiempo promedio que tardó el cliente en contestar el primer mensaje de la IA.",
          atencionHumana:
            "Indica si una persona del equipo intervino en el chat dentro del horario de atención.",
          objetoReclamo:
            "Tema principal de cada reclamo, identificado por la IA al cerrar la conversación.",
          etiquetas:
            "Etiquetas de interés —por ejemplo, interés en comprar— que la IA marcó en las conversaciones.",
          breakdowns:
            "Los mismos resultados separados por sucursal y por tipo de encuesta, para comparar.",
          canalVenta:
            "Canal de venta: P = Convencional, PA = Plan de ahorro. El dato está disponible en las ventas a partir del 24/06/2026.",
        },
        heroTitle: "Estadísticas por asistente IA",
        detailTitle: "Detalle del asistente",
        backToHero: "Volver al resumen",
        disabled: "El módulo de estadísticas no está habilitado para tu empresa.",
        modeTV: "Modo TV",
        exitTV: "Salir",
        clientSummary: "Resumen del cliente",
        selectAssistant: "Ver asistente",
        breakdowns: {
          title: "Detalle por segmento",
          bySucursal: "Por sucursal",
          byTipoEncuesta: "Por tipo de encuesta",
          bySubtipo: "Por subtipo",
        },
        canalVenta: {
          title: "Canal de venta",
          filterLabel: "Canal de venta",
          all: "Todos",
          convencional: "Convencional",
          planAhorro: "Plan de ahorro",
          sinDato: "Sin dato",
          availabilityNote:
            "Dato disponible desde el 24/06/2026 · ventas anteriores sin registrar.",
          tooltip:
            "Canal de venta: P = Convencional, PA = Plan de ahorro. Disponible en ventas desde el 24/06/2026.",
        },
        cards: {
          horasAhorradas: "Horas ahorradas",
          horasAhorradasCaption: "{{name}} te ahorró {{n}} horas",
          cobertura: "Cobertura 24/7",
          coberturaCaption: "{{pct}} atendido fuera de horario, 0 esperando a un humano",
          reclamos: "Reclamos a tiempo",
          reclamosCaption: "{{n}} reclamos detectados a tiempo",
          iaVsHumano: "IA vs humano",
          iaVsHumanoCaption: "{{ia}} IA / {{hum}} humano",
        },
        table: {
          asistente: "Asistente",
          tipo: "Tipo",
          enviados: "Enviados",
          respondieron: "Respondieron",
          tasaResp: "Tasa resp.",
          reclamos: "Reclamos",
        },
        filters: {
          dateRange: "Rango de fechas",
          from: "Desde",
          to: "Hasta",
          sucursal: "Sucursal",
          tipoEncuesta: "Tipo de encuesta",
          all: "Todas",
          service: "Service",
          venta: "Venta",
          // planAhorro: "Plan de ahorro", // F-next: cuando exista subtipo
        },
        funnel: {
          title: "Embudo",
          enviados: "Enviados",
          respondieron: "Respondieron",
          clasificados: "Clasificados",
        },
        kpis: {
          title: "Indicadores",
          satisfechos: "Satisfechos",
          reclamos: "Reclamos",
          sinRespuesta: "Sin respuesta",
          sobreTotal: "sobre total",
          sobreRespondieron: "sobre respondieron",
          tasaRespuesta: "Tasa de respuesta",
          tasaAccion: "Tasa de acción de Sofía",
          objetoReclamo: "Objeto del reclamo",
          tagsTrackeados: "Etiquetas seguidas",
          interesadoComprar: "Interesado en comprar",
          primeraRespuesta: "1ª respuesta del cliente",
          atencionHumana: "Atención humana en horario",
          atendidoHorario: "Atendido en horario",
          atendidoCierre: "Atendido al cierre del día",
          si: "Sí",
          no: "No",
        },
        insights: {
          title: "Recomendaciones",
          recommendations: "{{count}} recomendación",
          recommendations_plural: "{{count}} recomendaciones",
          severityWarning: "Advertencia",
          severityInfo: "Info",
          severitySuccess: "Logro",
          severityOportunidad: "Oportunidad",
          severitySofiaEnAccion: "Sofía en acción",
          ventana_muerta:
            "Sofía atiende a toda hora. {{count}} encuestas salieron después de las {{horaLimiteDisparo}}h; como el aviso al equipo recién se dispara {{timeoutHours}}h más tarde, los pocos que no responden no alcanzan a pasar a una persona antes del cierre. Disparándolas más temprano se recupera ese margen.",
          disparo_tardio:
            "Sofía dispara las encuestas cerca de las {{medianaHoraDisparo}}h. Adelantando el envío, más clientes que no responden alcanzan a pasar al equipo antes del cierre.",
          timeout_absorbe:
            "El {{pct}} no respondió dentro de la ventana. Sofía quedó disponible igual para cuando quieran retomar.",
          reclamo_sin_atencion:
            "Sofía detectó y marcó {{count}} reclamos el mismo día. Para cerrar el círculo, conviene que una persona los tome antes del cierre.",
          buena_cobertura:
            "Sofía respondió {{fueraHorarioCount}} encuestas fuera de horario — atención que un humano no habría dado.",
          generic: "Recomendación disponible.",
        },
        units: {
          horas: "h",
          seg: "s",
          min: "min",
        },
        empty: {
          noData: "Aún no hay datos para este período.",
          noAssistants: "Este cliente todavía no tiene asistentes con estadísticas.",
          noObjeto: "Sin objetos de reclamo en este período.",
          noTags: "Sin etiquetas seguidas en este período.",
          noPeriod: "Sin datos en este período.",
        },
      },
      chatInput: {
        systemChannelReadOnly: "Canal de avisos automáticos. No se pueden enviar mensajes.",
      },
      matchpropBanner: {
        text: "Tenés {{count}} coincidencia(s) de propiedades sin revisar en MatchProp",
        goToChat: "Ir al chat de Alertas Propiedades",
      },
      chatHighlight: {
        needsAttention: "Requiere atención",
        matchprop: "Coincidencia de propiedad",
      },
      matchpropCard: {
        title: "Coincidencia detectada",
        test: "PRUEBA",
        levelExact: "EXACTO",
        levelSimilar: "PARECIDO",
        requestLabel: "Pedido",
        inGroup: "en grupo {{group}}",
        operacion: "Operación",
        tipo: "Tipo",
        dorms: "Dorm.",
        zonas: "Zonas",
        precioMax: "Precio máx.",
        matchesHeader: "Coincidencias",
        priceOnRequest: "precio a consultar",
        viewListing: "Ver ficha",
        contactAuthor: "Escribirle a {{name}}",
        contactAuthorShort: "Escribirle al colega",
        viewInGroup: "Ver pedido en el grupo",
        contactOk: "Chat del colega abierto",
        groupNotFound: "No se encontró el chat del grupo",
        actionError: "No se pudo completar la acción",
      },
      turnosIA: {
        // Chequeo de alta (feat_366). El texto del backend viaja como
        // defaultValue; esto es la versión traducible.
        setupHealth: {
          titulo: "A esta empresa le falta terminar el alta de TurnosIA",
          token: {
            queFalta: "La empresa no tiene su token de WAIA configurado.",
            comoResolver: "Se copia solo al activar el módulo TurnosIA desde WAIA: apagá y volvé a prender ese switch.",
          },
          rubro: {
            queFalta: "La empresa no tiene un rubro aplicado.",
            comoResolver: "Desde el panel superadmin de TurnosIA, elegí la plantilla de rubro: siembra especialidades, campos y el vocabulario del negocio.",
          },
          especialidades: {
            queFalta: "No hay ninguna especialidad cargada, así que no se puede crear un profesional.",
            comoResolver: "Aplicá una plantilla de rubro (las siembra) o cargalas a mano desde Servicios.",
          },
        },
        bandeja: {
          tituloTarjeta: "Casos para resolver",
          tituloInbox: "Bandeja de casos",
          sinCasos: "No hay casos pendientes. La IA está resolviendo todo sola. 🎉",
          sinNombre: "Sin nombre",
          enCurso: "En curso",
          tomar: "Tomar",
          resuelto: "Resuelto",
          resolverTurno: "Agendar",
          asignarTurno: "Asignar {{appointment}}",
          verTurno: "Ver {{appointment}}",
          notasTurno: "Notas {{delAppointment}}",
          abrirChat: "Abrir chat",
          sinTelefonoValido: "Sin teléfono válido",
          chatNoEncontrado: "No se encontró un chat abierto para este contacto.",
          tomadoOk: "Caso tomado",
          resueltoOk: "Caso resuelto",
          errorGuardar: "No se pudo actualizar el caso",
          turnoCreadoHint: "Listo, quedó agendado. Si el caso está resuelto, marcalo como Resuelto.",
          turnoRelacionado: "{{appointment_c}} relacionado",
          motivo: "Motivo",
          horaCaso: "Hora",
          transcriptNoDisponible: "El detalle de la conversación no está disponible en esta vista.",
          conversacion: "Conversación",
          reason: {
            fuera_de_alcance: "Fuera de alcance",
            pidio_humano: "Pidió un humano",
            sin_disponibilidad: "Sin disponibilidad",
            reclamo: "Reclamo",
            urgente: "Urgente",
            fallo_tecnico: "Falla técnica",
            otro: "Otro",
          },
        },
        vocabDefaults: {
          patient: "paciente", patientPlural: "pacientes",
          patientName: "Nombre del paciente", patientPhone: "Teléfono",
          professional: "profesional", professionalPlural: "profesionales",
          appointment: "turno", appointmentPlural: "turnos",
          specialty: "especialidad", specialtyPlural: "especialidades",
          service: "servicio", servicePlural: "servicios",
          waitingRoom: "sala de espera", waitingRoomPlural: "salas de espera",
          cobertura: "cobertura", coberturaPlural: "coberturas",
          scheduler: "agendador", schedulerPlural: "agendadores",
          room: "consultorio", roomPlural: "consultorios",
          patientGen: "m", professionalGen: "m", appointmentGen: "m", specialtyGen: "f",
          serviceGen: "m", waitingRoomGen: "f", coberturaGen: "f", schedulerGen: "m", roomGen: "m",
        },
        metricas: {
          widget: {
            verMas: "Ver más",
            verMasTooltip: "Ver la página completa de métricas",
            tooltip: "Lo que el asistente hizo por tu negocio",
            vacio: "Acá vas a ver lo que el asistente hace por vos: {{appointmentPlural}} que agenda solo y {{appointmentPlural}} que recupera cuando alguien cancela. Todavía sin actividad para mostrar.",
            mes: "En lo que va del mes",
            d30: "Últimos 30 días",
            agendadosSolos: "{{appointmentPlural}} se agendaron solos",
            seAgendaronSolos: "se agendaron solos",
            de: "de",
            recuperados: "recuperados",
            previos: "30 días previos: {{n}}",
          },
          filtroProfesional: "{{professional_c}}",
          filtroServicio: "{{service_c}}",
          sinFiltro: "Sin filtrar",
          errorCarga: "No se pudieron cargar las métricas. Probá de nuevo en un momento.",
          d7: "7 días", d30: "30 días", d90: "90 días", m12: "12 meses",
          aTitulo: "Lo que el asistente hizo por tu negocio",
          aSub: "El retorno del asistente en el período elegido.",
          aVacio: "Acá vas a ver lo que el asistente hace por vos: {{appointmentPlural}} que agenda solo, {{appointmentPlural}} que recupera cuando alguien cancela, y las consultas que deriva a una persona. Todavía sin actividad para mostrar.",
          aAgendadosSolos: "{{appointmentPlural_c}} que agendó solo",
          aRecuperados: "recuperados por rebalanceo",
          aDerivados: "derivados a una persona",
          aCreadosTotal: "{{appointmentPlural}} en total",
          aCreadosRecuperados: "recuperados",
          aCreadosIA: "agendados por la IA",
          aCreadosMano: "cargados a mano",
          aSerieRecuperados: "Recuperados",
          aNotaDesde: "Lo que agendó el asistente se cuenta desde el {{fecha}} (cuando empezó a registrar su origen). Antes de esa fecha no se muestra, para no confundir con ceros.",
          bTitulo: "Salud de la agenda",
          bSub: "Cómo se comportó el período.",
          bVacio: "Cuando haya movimiento en el período vas a ver acá cuántos se completaron, cuántos se cancelaron (y con cuánta anticipación) y cuántos no se presentaron.",
          bCompletados: "Completados",
          bCancelados: "Cancelados",
          bNoShow: "No se presentaron",
          bAnticipacion: "Anticipación al cancelar",
          bAnticipacionSub: "promedio · {{n}} cancelación(es)",
          bAnticipacionVacio: "sin cancelaciones con fecha",
          bTasaConfirmacion: "Tasa de confirmación",
          bTasaSub: "{{r}}/{{s}} respondieron · {{elPatient}}, no el panel",
          bTasaVacio: "sin recordatorios de confirmación en el período",
          cTitulo: "Calidad de la atención",
          cSub: "Puntualidad, espera y duración real. Se calcula cuando el equipo marca llegada / llamada / inicio / fin.",
          cVacio: "Cuando el equipo use el flujo de atención (marcar que llegó, que se lo llamó y cuándo empezó y terminó) vas a ver acá la puntualidad, cuánto se espera y la duración real.",
          cPuntualidad: "Puntualidad (demora media al iniciar)",
          cPuntualidadSub: "{{pct}}% a horario · {{n}} atendidos",
          cEspera: "Espera media",
          cEsperaSub: "{{n}} con hora de llegada",
          cEsperaVacio: "sin registro de llegada",
          cDuracion: "Duración real (media)",
          cDuracionSub: "estimado {{est}} min · {{n}} atendidos",
          cSinDatos: "sin datos aún",
          dTitulo: "Actividad del asistente",
          dSub: "Derivaciones a una persona y recordatorios enviados.",
          dVacio: "Acá vas a ver por qué motivos el asistente derivó consultas a una persona y cuántos recordatorios envió. Todavía sin actividad en el período.",
          dMotivos: "Motivos de derivación ({{n}})",
          dSinDerivaciones: "Sin derivaciones en el período.",
          dRecordatorios: "Recordatorios enviados ({{s}} de {{t}})",
          dSinRecordatorios: "Sin recordatorios en el período.",
          dDerivaciones: "Derivaciones",
          dEnviados: "Enviados",
          dFallidos: "Fallidos",
          pie: "Período {{from}} → {{to}}. Los números provienen del sistema y son verificables; las métricas que hoy no se pueden calcular con confianza no se muestran.",
          rConfirmacionReserva: "Confirmación de reserva",
          rRecordatorio: "Recordatorio",
          rPedidoConfirmacion: "Pedido de confirmación",
          rOfertaLiberado: "Oferta de lugar liberado",
          rOfertaListaEspera: "Oferta de lista de espera",
        },
        menu: {
          metricas: "Métricas",
          agenda: "Agenda",
          profesionales: "Profesionales",
          agendadores: "Agendadores",
          servicios: "Servicios",
          disponibilidad: "Disponibilidad",
          precios: "Precios",
          listaEspera: "Lista de Espera",
          recordatorios: "Recordatorios",
          ajustes: "Ajustes",
          miAgenda: "Mi Agenda",
        },
        calendar: {
          title: "Calendario",
          day: "Día",
          week: "Semana",
          month: "Mes",
          today: "Hoy",
          prev: "Anterior",
          next: "Siguiente",
          noEvents: "No hay {{appointmentPlural}} en este rango.",
          colorByProfessional: "Color por {{professional}}",
          colorByStatus: "Color por estado",
          allProfessionals: "Sin filtrar",
          allAssigned: "Sin filtrar (solo asignados)",
          outOfHours: "Fuera del horario disponible",
          movePast: "No se puede mover nada al pasado",
          moveConfirmTitle: "Reprogramar",
          moveConfirmText: "¿Mover a {{name}} del {{oldDateTime}} al {{newDateTime}}? Le avisamos por WhatsApp.",
          moveCancelar: "Cancelar",
          moveConfirmar: "Confirmar",
          moveSuccess: "Listo, quedó reprogramado",
          moveErrorGeneric: "No se pudo mover",
          moveOccupied: "El horario ya está ocupado",
          moveNoPermission: "No tenés permiso para mover {{appointmentPlural}}",
          moveDiscarded: "No se pudo soltar ahí. Probá de nuevo soltándolo sobre el día y la hora que querés.",
          refresh: "Actualizar",
        },
        tabs: {
          agendaDesc: "El día de hoy, organizado por quién atiende. Podés llamar al siguiente y mandarle un recordatorio.",
          profesionalesDesc: "Gestioná quiénes reciben {{appointmentPlural}}. Podés agregar, editar o desactivar.",
          agendadoresDesc: "Quiénes cargan {{appointmentPlural}} a mano y pueden habilitar sobreturnos. Podés agregar, editar o desactivar.",
          serviciosDesc: "Configurá qué se ofrece, cuánto dura y quién lo atiende.",
          disponibilidadDesc: "Configurá horarios de atención y bloqueos de agenda, uno por uno.",
          preciosDesc: "La lista de precios de la empresa. Se carga desde un archivo y se puede corregir a mano.",
          listaEsperaDesc: "Quiénes esperan un lugar, y el historial de rebalanceos automáticos.",
          recordatoriosDesc: "Historial de mensajes enviados y programados.",
          ajustesDesc: "Configuración de integración, recordatorios y plantillas de mensajes.",
        },
        status: {
          available: "Disponible",
          reserved: "Reservado",
          completed: "Completado",
          cancelled: "Cancelado",
          pending: "Pendiente",
          confirmed: "Confirmado",
          in_progress: "En atención",
          arrived: "En sala",
          called: "Llamado",
          no_show: "Ausente",
        },
        panel: {
          servicio: "Servicio",
          profesional: "Profesional",
          fechaHora: "Fecha y hora",
          consultorio: "Consultorio",
          telefono: "Teléfono",
          sobreturno: "Sobreturno",
          cambiarEstado: "Cambiar estado",
          estadoActualizado: "Estado actualizado",
          estadoError: "No se pudo cambiar el estado",
          notas: "Notas",
          acciones: "Acciones",
          historial: "Historial",
          proximamente: "Próximamente",
          cerrar: "Cerrar",
          notasVacio: "Sin notas todavía",
          notaPlaceholder: "Agregar una nota...",
          notaAgregar: "Agregar",
          notaCreada: "Nota agregada",
          notaError: "No se pudo agregar la nota",
          cancelarConMotivo: "Cancelar con motivo",
          cancelarMotivoLabel: "Motivo",
          cancelarTitulo: "Cancelar",
          cancelarOk: "Cancelado, le avisamos por WhatsApp",
          cancelarError: "No se pudo cancelar",
          eliminar: "Eliminar",
          eliminarTitulo: "Eliminar",
          eliminarTexto: "Se saca de la agenda, pero queda en el historial.",
          eliminarMotivoLabel: "Motivo (opcional)",
          eliminarOk: "Eliminado",
          eliminarError: "No se pudo eliminar",
          reAvisarBtn: "Re-avisar",
          reAvisarOk: "Aviso enviado",
          reAvisarError: "No se pudo reenviar el aviso",
          llamarBtn: "Llamar",
          llamarOk: "Pasó a en atención",
          llamarError: "No se pudo llamar",
          abrirChatBtn: "Abrir chat",
          sinConversacion: "Sin conversación",
          sinTelefonoValido: "Sin teléfono válido",
          dialogCancelar: "Cancelar",
          dialogConfirmar: "Confirmar",
          reprogramar: "Reprogramar",
          reprogramarTitulo: "Reprogramar",
          reprogramarFecha: "Nueva fecha",
          reprogramarHorario: "Horario disponible",
          reprogramarSinSlots: "No hay horarios disponibles ese día",
          reprogramarConfirmar: "Reprogramar",
          reprogramarAviso: "Le avisamos por WhatsApp.",
          reprogramarOk: "Reprogramado, le avisamos por WhatsApp",
          reprogramarError: "No se pudo reprogramar",
          score: {
            cancelo: "Canceló",
            ausente: "Ausente",
            clienteRiesgo: "{{patient_c}} de riesgo",
          },
        },
        overtime: {
          configurar: "Configurar sobreturno",
          finDelDia: "Sobreturno al final del día",
          entreTurnos: "Sobreturno intercalado",
          maxSobreturnos: "Máx. sobreturnos del día",
          guardar: "Guardar",
          guardado: "Configuración guardada",
          cancelar: "Cancelar",
          yaHayTurno: "Ya hay algo con {{name}} a esa hora",
          badge: "Sobreturno",
          cargarSobreturno: "Cargar sobreturno",
          activarHint: "Activá sobreturno para hoy para poder cargar uno",
          sinDisponibles: "No hay sobreturnos disponibles",
        },
        atencion: {
          llego: "Llegó",
          llegoTooltip: "Marcar que el cliente ya está acá. Evita que le llegue el «¿estás llegando?»",
          llegoOk: "{{nombre}}: llegada registrada",
          llegoError: "No se pudo registrar la llegada",
          llamar: "Llamar",
          llamarError: "No se pudo llamar",
          comenzarAtencion: "Comenzar atención",
          comenzarError: "No se pudo comenzar la atención",
          rellamar: "Rellamar",
          rellamarOk: "Aviso reenviado",
          rellamarError: "No se pudo reenviar el aviso",
          cancelarAusente: "Cancelar (ausente)",
          confirmarAusenteTitulo: "¿Marcar como ausente?",
          confirmarAusenteTexto: "Se libera el lugar y queda registrado como ausente.",
          ausenteOk: "Marcado como ausente",
          ausenteError: "No se pudo marcar como ausente",
          enAtencion: "En atención",
          terminarAtencion: "Terminar atención",
          terminarError: "No se pudo terminar la atención",
          horaObjetivo: "Hora objetivo de cierre",
          enMin: "en ~{{min}} min",
          etaTooltip: "Hora estimada de atención (se recalcula)",
          avisoSonoroOn: "Aviso sonoro activado",
          avisoSonoroOff: "Aviso sonoro desactivado",
          nudgeSobreturno: "Vas adelantado — ¿cargar un sobreturno?",
          ahora: "Ahora",
          diaEnHora: "En hora",
          diaAtrasado: "Atrasado +{{min}}min",
          diaAdelantado: "Adelantado −{{min}}min",
          sugerido: "Sugerido",
          fichaTitulo: "Llamado",
          fichaServicio: "Servicio",
          fichaTelefono: "Teléfono",
          minAbrev: "min",
        },
        header: {
          servicioActivo: "Servicio activo",
          servicioNoDisponible: "Servicio no disponible",
          title: "TurnosIA — {{appointmentPlural_c}}",
          noAcceso: "No tenés acceso a este módulo.",
          contactarAdmin: "Contactá al administrador para habilitarlo.",
          volver: "Volver",
          backendNoResponde: "El backend de TurnosIA no responde.",
        },
        agendaHoy: "Agenda de hoy",
        turnosHoy: "Turnos de hoy",
        proximosTurnos: "A continuación",
        sobretornosHoy: "Sobreturnos habilitados",
        sinTurnosHoy: "Nada para hoy",
        sinTurnosProximos: "No hay turnos programados próximamente.",
        sinTurnosPropios: "No tenés nada programado próximamente.",
        noTurnosHoy: "No tenés nada para hoy.",
        vasAdelantado: "Vas adelantado en la agenda. Podés habilitar un sobreturno para hoy.",
        profesionalAdelantado: "Van adelantados en la agenda. Podés habilitar un sobreturno para hoy.",
        misBloques: "Mis Bloques Especiales",
        sinSlots14Dias: "Sin slots en los próximos 14 días.",
        slotsEspecialesHoy: "Slots especiales de hoy",
        libresCount: "{{count}} libres",
        reservadosCount: "{{count}} reservados",
        adelantado: "adelantado",
        atrasado: "atrasado",
        ignorar: "Ignorar",
        tabAgenda: "Agenda",
        tabMisBloques: "Mis Bloques",
        profesional: "Profesional",
        alertasTurnosEspeciales: "{{count}} alerta{{plural}} de bloques especiales",
        importTurnos: {
          boton: "Cargar Excel",
          historialBoton: "Cargas por Excel",
          titulo: "Carga de {{appointmentPlural}} por Excel",
          tabCargar: "Cargar archivo",
          tabHistorial: "Historial",
          intro: "Subí el listado del sistema anterior. Primero vas a ver qué cambia; no se guarda nada hasta que confirmes.",
          elegirArchivo: "Elegí el archivo (.xls o .xlsx)",
          verConfig: "Configuración de la carga",
          ocultarConfig: "Ocultar configuración",
          servicioDefault: "Servicio con el que se cargan",
          servicioDefaultAyuda: "El archivo no trae el servicio: todos se cargan con este.",
          sinServicio: "Sin configurar",
          recordatoriosDefault: "Las cargas nuevas reciben recordatorios programados",
          configGuardada: "Configuración guardada",
          errorConfig: "No se pudo guardar la configuración",
          errorLeer: "No se pudo leer el archivo",
          errorImportar: "No se pudo completar la carga",
          errorRevertir: "No se pudo revertir la carga",
          noSePuedeImportar: "El archivo tiene problemas y no se puede cargar:",
          radio: "Se crean {{crear}} y se cancelan {{cancelar}}. No se envía ningún mensaje ahora.",
          radioRecordatorios: "Se programan {{n}} recordatorios.",
          radioSinRecordatorios: "Estos {{appointmentPlural}} no van a recibir recordatorios.",
          radioInmediatos: "{{n}} de esos recordatorios salen en los próximos minutos: su hora de envío ya llegó.",
          rangoDeclarado: "Rango del archivo: del {{desde}} al {{hasta}} (declarado en la fila {{fila}}).",
          rangoDerivado: "Rango del archivo: del {{desde}} al {{hasta}} (calculado con las filas: el archivo no lo declara).",
          sinRango: "No se pudo determinar el rango del archivo.",
          rangoEfectivo: "Se compara a partir del {{desde}}: lo anterior no se crea ni se cancela.",
          servicioUsado: "Servicio: {{nombre}}",
          chipLeidas: "{{n}} filas leídas",
          chipCrear: "{{n}} a crear",
          chipExistentes: "{{n}} ya existen",
          chipPasadas: "{{n}} pasadas (se ignoran)",
          chipCancelar: "{{n}} a cancelar",
          chipIncidencias: "{{n}} incidencias",
          checksumOk: "Control de filas: {{leidas}} de {{declaradas}}",
          checksumMal: "Control de filas NO coincide: {{leidas}} leídas, {{declaradas}} declaradas",
          telefonos: "Teléfonos: {{moviles}} con 15, {{asumidos}} tomados como celular, {{invalidos}} inválidos",
          switchRecordatorios: "Enviar recordatorios programados a estos {{appointmentPlural}}",
          switchRecordatoriosAyuda: "No se manda la confirmación de reserva: el cliente ya lo arregló con el asesor.",
          asesoresTitulo: "Asesores del archivo y su {{professional}}",
          asesoresSinAsociar: "{{n}} sin asociar: sus filas no se cargan",
          sinAsociar: "Sin asociar",
          guardarAsesores: "Guardar asociaciones",
          cancelarTitulo: "Se cancelan {{n}} {{appointmentPlural}}",
          cancelarAyuda: "Se habían cargado desde un archivo anterior y ya no figuran en este. Nunca se cancela lo que agendó el asistente o se cargó a mano.",
          colCliente: "Cliente",
          colSucursal: "{{professional_c}}",
          colFecha: "Fecha",
          colHora: "Hora",
          incidenciasTitulo: "{{n}} filas con incidencias (no se cargan)",
          protegidosTitulo: "{{n}} {{appointmentPlural}} no se cancelan porque su fila tiene una incidencia",
          protegido: "{{cliente}} — {{fecha}} {{hora}}",
          fila: "Fila {{n}}",
          archivo: "Archivo",
          importado: "Carga #{{lote}}: {{creados}} creados, {{cancelados}} cancelados",
          importadoConIncidencias: "{{n}} filas no se cargaron: revisá las incidencias en el historial",
          revertido: "Carga #{{lote}} revertida: {{borrados}} borrados, {{restaurados}} restaurados",
          revertResultado: "Carga #{{lote}} revertida: {{borrados}} borrados y {{restaurados}} restaurados.",
          revertPasosSaltados: "{{n}} recordatorios que vencieron mientras el turno estaba cancelado no se van a enviar.",
          noRevertiblesTitulo: "{{n}} no se revirtieron (tuvieron cambios después de la carga):",
          historialVacio: "Todavía no hay cargas.",
          colCargado: "Cargado",
          colArchivo: "Archivo",
          colRango: "Rango",
          colCreados: "Creados",
          colCancelados: "Cancelados",
          colExistentes: "Ya existían",
          colIncidencias: "Incidencias",
          colEstado: "Estado",
          estadoRevertido: "Revertida",
          estadoAplicado: "Aplicada",
          sinRecordatorios: "sin recordatorios",
          revertir: "Revertir",
          historialAyuda: "Sólo se puede revertir la última carga aplicada.",
          cerrar: "Cerrar",
          confirmar: "Confirmar: crear {{crear}} y cancelar {{cancelar}}",
          revertirTitulo: "Revertir la carga #{{lote}}",
          revertirTexto: "Se borran los {{creados}} {{appointmentPlural}} que creó (salvo los que ya tuvieron cambios) y se restauran los {{cancelados}} que canceló. No se envía ningún mensaje."
        },
      },
      agenda: {
        cargarAMano: "Cargar a mano",
        asignarA: "Asignar a",
        sinRecurrencia: "Sin recurrencia",
        sinAcceso: "Sin acceso",
        accesoPermanente: "Acceso permanente",
        accesoPorCaso: "Por caso (requiere aprobación)",
        placeholderBloque: "ej: control, revisión, urgencia",
        alertasTitulo: "Alertas de bloques especiales cancelados",
        sinAlertas: "No hay alertas pendientes.",
        sinAsignados: "No tenés nada asignado todavía.",
        color: "Color:",
        slot: "Espacio:",
        nombrePaciente: "Nombre del paciente *",
        telefono: "Teléfono *",
        email: "Email (opcional)",
        profesional: "Profesional",
        profesionalReq: "Profesional *",
        servicio: "Servicio *",
        helperTelefono: "Con código de país, ej: 5493512345678",
        nombreBloque: "Nombre del bloque *",
        inicio: "Inicio *",
        fin: "Fin *",
        duracionSlot: "Duración por slot (minutos)",
        recurrencia: "Recurrencia",
        accesoAgendador: "Acceso {{delScheduler}}",
        fecha: "Fecha *",
        sinSlots: "Sin slots disponibles para esa fecha",
        seleccionarProfFechaSvc: "Elegí {{professional}}, fecha y {{service}}",
        guardarTurno: "Guardar",
        asignar: "Asignar",
        crearBloque: "Crear bloque",
        habilitarSobreturno: "Habilitar sobreturno",
        habilitarSobreturnos: "Habilitar sobreturnos",
        solicitarAcceso: "Solicitar acceso",
        actualizar: "Actualizar",
        llamarSiguiente: "Llamar siguiente",
        llamar: "Llamar",
        enviarRecordatorio: "Enviar recordatorio",
        agendadorSinAcceso: "{{scheduler_c}} sin acceso",
        agendadorConAcceso: "{{scheduler_c}} con acceso",
        desactivarBloque: "Desactivar bloque",
        especial: "Especial",
        libre: "Libre",
        reservado: "Reservado",
        pacienteNotificado: "Le avisamos por WhatsApp",
        turnoActualizadoSinWA: "Se actualizó, pero WhatsApp no estaba disponible",
        errorLlamarSiguiente: "Error al llamar siguiente",
        recordatorioEnviado: "Recordatorio enviado",
        errorRecordatorio: "Error al enviar recordatorio",
        sobreturnuHabilitado: "Sobreturno habilitado para hoy",
        errorSobreturno: "No se pudo habilitar el sobreturno",
        sobretornosHabilitados: "Sobreturnos habilitados para hoy",
        sobretornosDeshabilitados: "Sobreturnos deshabilitados",
        errorSobreturnos: "Error al actualizar sobreturnos",
        bloqueCreado: "Bloque especial creado",
        errorBloque: "Error al crear el bloque",
        pacienteAsignado: "Quedó asignado al bloque especial",
        errorAsignar: "No se pudo asignar",
        errorAsignarSimple: "Error al asignar",
        solicitudEnviada: "Solicitud enviada",
        errorSolicitud: "Error al enviar la solicitud",
        errorAcceso: "No se pudo actualizar el acceso",
        bloqueDesactivado: "Bloque desactivado",
        errorDesactivar: "Error al desactivar el bloque",
        errorCargarDatos: "Error al cargar datos",
        camposObligatorios: "Completá todos los campos obligatorios (*)",
        campoRequerido: "El campo \"{{label}}\" es requerido",
        eligeHorario: "Elegí un horario",
        turnoCargado: "Listo, quedó agendado",
        errorCargarTurno: "No se pudo agendar",
        usuarioSinProfesional: "Tu usuario no está vinculado. Contactá al administrador.",
        errorProfesionales: "No se pudo cargar la lista.",
      },
      profesionales: {
        titulo: "Profesionales",
        agregarBtn: "Agregar",
        headerNombre: "Nombre",
        headerEspecialidad: "Especialidad",
        headerCapacidad: "Simultáneos",
        headerCupoDiario: "Tope por día",
        headerEstado: "Estado",
        headerAcciones: "Acciones",
        sinProfesionales: "Todavía no cargaste {{professionalPlural}}.",
        sinEspecialidad: "Sin {{specialty}}",
        cancelar: "Cancelar",
        nuevo: "Agregar {{professional}}",
        editar: "Editar {{professional}}",
        activo: "Activo",
        inactivo: "Inactivo",
        activar: "Activar",
        desactivar: "Desactivar",
        nombre: "Nombre *",
        especialidad: "Especialidad",
        emailReq: "Email *",
        email: "Email",
        passwordReq: "Contraseña *",
        nuevaPassword: "Nueva contraseña",
        helperPassword: "Dejar vacío para no cambiar",
        consultorio: "Consultorio",
        capacidad: "Atención simultánea",
        capacidadUnidad: "turnos",
        capacidadAyuda: "Cuántos {{appointmentPlural}} puede atender al mismo tiempo (1 = uno por vez)",
        cupoDiario: "Tope de turnos por día",
        cupoDiarioAyuda: "Opcional. Vacío = sin tope. Acota lo que agenda el asistente; desde el panel se puede cargar igual.",
        consultorioPlaceholder: "ej: 1, 3, A",
        queueWarning: "El usuario fue creado pero no se pudo asignar una cola. Asignala manualmente desde WAIA.",
        guardar: "Guardar",
        errorNombre: "El nombre es requerido",
        errorCredenciales: "Email y contraseña son requeridos",
        errorGuardar: "No se pudo guardar. Revisá los datos y volvé a intentar.",
        tooltipEditar: "Editar",
      },
      precios: {
        titulo: "Precios",
        importar: "Importar",
        historial: "Historial",
        sinLista: "Todavía no cargaste una lista de precios.",
        vigenteDesdeChip: "Vigente desde {{fecha}}",
        importadaEl: "Importada el {{fecha}}",
        listaVencida: "Esta lista tiene {{dias}} días y el límite configurado es de {{umbral}}. Actualizala: el asistente no va a dar precios de una lista vencida.",
        buscar: "Buscar",
        todos: "Todos",
        headerPrecio: "Precio",
        headerAcciones: "Acciones",
        headerItems: "Precios",
        headerEstado: "Estado",
        noAplica: "No aplica",
        estadoActivo: "Con precio",
        sinResultados: "Ningún precio coincide con el filtro.",
        editar: "Corregir",
        editarTitulo: "Corregir precio",
        etiqueta: "Etiqueta",
        helperPrecio: "Dejalo vacío si no tiene precio cargado.",
        helperEtiqueta: 'Para ofertas con nombre, como "Revisión Gratuita". Se dice en lugar del número.',
        avisoAtributos: "Para cambiar a qué corresponde este precio, corregí el archivo y volvé a importarlo.",
        rangoFiltroPlaceholder: "Escribí un valor",
        borrarLista: "Borrar",
        estado_active: "En uso",
        estado_archived: "Archivada",
        estado_draft: "Borrador",
        importarTitulo: "Importar lista de precios",
        formato: "Tipo de planilla",
        formato_matrix_km: "Una fila por vehículo y una columna por kilometraje",
        formato_long_csv: "CSV: un precio por fila",
        formatoHelp_matrix_km: "El mural de siempre: cada fila es un modelo, cada columna un service (10.000, 20.000…) y los adicionales al final.",
        formatoHelp_long_csv: "Una fila por precio. Las columnas que no sean precio, estado, etiqueta o nota se toman como datos del precio.",
        formato_ejes_declarados: "Con hoja de configuración (CONFIG)",
        formatoHelp_ejes_declarados: "La planilla nueva: además de los precios trae una hoja CONFIG que dice qué es cada columna (modelo, versión, años, kilometraje).",
        rechazan: "{{count}} problema que impide importar",
        cobertura: "Cobertura por sujeto",
        sinPreciosPara: "sin precios para {{v}}",
        dejarEnBorrador: "Dejar en borrador (no reemplaza la lista vigente todavía)",
        avisoBorrador: "La lista se carga pero NO entra en uso: podés revisarla y activarla después. El asistente sigue contestando con la lista vigente.",
        elegirArchivo: "Tocá acá para elegir el archivo (.xlsx o .csv)",
        resumen: "Qué trae el archivo",
        ejes: "Se agrupa por",
        chipTotal: "{{n}} precios",
        chipActivos: "{{n}} con precio",
        chipNoAplica: "{{n}} no aplica",
        chipOmitidas: "{{n}} no se cargan",
        diffPrimera: "Es la primera lista: todo es nuevo.",
        diffContra: 'Comparado con "{{lista}}"',
        diffNuevos: "{{n}} nuevos",
        diffSubieron: "{{n}} subieron",
        diffBajaron: "{{n}} bajaron",
        diffIguales: "{{n}} sin cambios",
        diffCambiosEstado: "{{n}} cambian de estado",
        diffDesaparecidos: "{{n}} desaparecen",
        diffItem: "Ítem",
        diffAntes: "Antes",
        diffDespues: "Ahora",
        diffCambio: "Cambio",
        diffKind_nuevo: "Nuevo",
        diffKind_subio: "Subió",
        diffKind_bajo: "Bajó",
        diffKind_igual: "Sin cambios",
        diffKind_cambio_estado: "Cambia de estado",
        diffKind_desaparecido: "Desaparece",
        noSeCargan: "{{count}} celda no se va a cargar",
        avisos: "{{count}} aviso",
        nombreLista: "Nombre de la lista",
        vigenteDesde: "Vigente desde",
        vigenciaDelArchivo: "La tomamos del archivo. Cambiala si no es correcta.",
        vigenciaFaltante: "El archivo no la trae: indicá desde cuándo rige.",
        incluyeIva: "¿Los precios incluyen IVA?",
        ivaSi: "Sí, incluyen IVA",
        ivaNo: "No, no incluyen IVA",
        ivaNoSe: "No se sabe",
        avisoReemplazo: "Al confirmar, esta lista pasa a ser la vigente y la anterior queda archivada.",
        errorLeer: "No se pudo leer el archivo.",
        errorImportar: "No se pudo importar el archivo.",
        validezTitulo: "Vencimiento de la lista de precios",
        validezLabel: "Avisar cuando la lista tenga más de (días)",
        validezHelper: "Vacío = sin control de vencimiento. Con un número, la lista se marca vencida pasados esos días y el asistente deja de dar precios de ella.",
        formatoDetectado: "Tipo de planilla (lo reconocimos solos)",
        formatoDetectadoHelp: "Lo elegimos mirando el archivo. Cambialo sólo si no es correcto: el archivo se vuelve a leer.",
        importarAyuda: "Es la lista de precios que usa el asistente para contestar consultas. Subí el Excel que mantiene la empresa: antes de guardar nada te mostramos qué trae, qué cambia contra la lista actual y qué hay que corregir.",
        archivoElegido: "{{nombre}} — tocá para elegir otro",
        leyendoArchivo: "Leyendo el archivo…",
        rechazan_plural: "{{count}} problemas que impiden importar",
        rechazanAyuda: "Corregilos en el Excel (la celda está al lado de cada uno) y volvé a elegir el archivo.",
        noSeCargan_plural: "{{count}} celdas no se van a cargar",
        avisos_plural: "{{count}} avisos",
        incGenerico: "{{count}} caso",
        incGenerico_plural: "{{count}} casos",
        incVerTodas: "Ver los {{n}}",
        incVerMenos: "Ver menos",
        incMasCeldas: "y {{n}} más",
        inc_CELDA_CON_ERROR: "{{count}} celda con error de fórmula",
        inc_CELDA_CON_ERROR_plural: "{{count}} celdas con error de fórmula",
        inc_COLUMNA_IGNORADA: "{{count}} columna que no es un kilometraje válido",
        inc_COLUMNA_IGNORADA_plural: "{{count}} columnas que no son un kilometraje válido",
        inc_CONFIG_CLAVE_IGNORADA: "{{count}} dato de la hoja CONFIG que no se usa",
        inc_CONFIG_CLAVE_IGNORADA_plural: "{{count}} datos de la hoja CONFIG que no se usan",
        inc_CONFIG_IVA_ILEGIBLE: "El IVA de la hoja CONFIG no se pudo leer",
        inc_CONFIG_IVA_ILEGIBLE_plural: "El IVA de la hoja CONFIG no se pudo leer",
        inc_EJES_INFERIDOS: "Las columnas se reconocieron solas",
        inc_EJES_INFERIDOS_plural: "Las columnas se reconocieron solas",
        inc_ESCALA_CON_SALTO: "{{count}} salto en los kilometrajes (puede faltar una columna)",
        inc_ESCALA_CON_SALTO_plural: "{{count}} saltos en los kilometrajes (puede faltar una columna)",
        inc_FILA_SIN_PRECIOS: "{{count}} fila sin ningún precio",
        inc_FILA_SIN_PRECIOS_plural: "{{count}} filas sin ningún precio",
        inc_ITEM_DUPLICADO: "{{count}} precio repetido",
        inc_ITEM_DUPLICADO_plural: "{{count}} precios repetidos",
        inc_MONEDA_IGNORADA: "La columna de moneda no se usa",
        inc_MONEDA_IGNORADA_plural: "La columna de moneda no se usa",
        inc_PRECIO_CERO_CON_ETIQUETA: "{{count}} precio en 0 que se dice con su observación",
        inc_PRECIO_CERO_CON_ETIQUETA_plural: "{{count}} precios en 0 que se dicen con su observación",
        inc_PRECIO_CERO_SIN_ETIQUETA: "{{count}} precio en 0 sin observación",
        inc_PRECIO_CERO_SIN_ETIQUETA_plural: "{{count}} precios en 0 sin observación",
        inc_PRECIO_COMO_TEXTO: "{{count}} precio escrito como texto",
        inc_PRECIO_COMO_TEXTO_plural: "{{count}} precios escritos como texto",
        inc_RANGO_CON_HUECO: "{{count}} hueco entre años",
        inc_RANGO_CON_HUECO_plural: "{{count}} huecos entre años",
        inc_RANGO_INVALIDO: "{{count}} rango de años mal escrito",
        inc_RANGO_INVALIDO_plural: "{{count}} rangos de años mal escritos",
        inc_SEPARADOR_AMBIGUO: "{{count}} precio con separador dudoso",
        inc_SEPARADOR_AMBIGUO_plural: "{{count}} precios con separador dudoso",
        inc_SUJETO_INCOMPLETO: "{{count}} fila con precios pero sin modelo",
        inc_SUJETO_INCOMPLETO_plural: "{{count}} filas con precios pero sin modelo",
        inc_SUJETO_VARIAS_PALABRAS: "{{count}} valor con palabras de más",
        inc_SUJETO_VARIAS_PALABRAS_plural: "{{count}} valores con palabras de más",
        inc_TEXTO_COMO_ETIQUETA: "{{count}} texto cargado como etiqueta",
        inc_TEXTO_COMO_ETIQUETA_plural: "{{count}} textos cargados como etiqueta",
        inc_RANGO_SOLAPADO: "{{count}} par de filas cuyos años se pisan",
        inc_RANGO_SOLAPADO_plural: "{{count}} pares de filas cuyos años se pisan",
        inc_RANGO_DOS_ABIERTOS: "{{count}} modelo con dos filas sin \"hasta\"",
        inc_RANGO_DOS_ABIERTOS_plural: "{{count}} modelos con dos filas sin \"hasta\"",
        ivaHelp_si: "El asistente puede decir que los precios incluyen IVA.",
        ivaHelp_no: "El asistente puede aclarar que los precios no incluyen IVA.",
        ivaHelp_nose: "El asistente no menciona el IVA.",
        ivaSiCorto: "Incluye",
        ivaNoCorto: "No incluye",
        ivaNoSeCorto: "No se sabe",
        incluyeIvaCorto: "IVA",
        crearPrecios: "Crear {{count}} precio",
        crearPrecios_plural: "Crear {{count}} precios",
        crearBorrador: "Crear {{count}} precio en borrador",
        crearBorrador_plural: "Crear {{count}} precios en borrador",
        crearSinArchivo: "Crear precios",
        creando: "Creando…",
        motivoSinArchivo: "Elegí un archivo para empezar.",
        motivoNoSeLeyo: "No se pudo leer el archivo: revisá el mensaje de arriba.",
        motivoErrores: "No se puede importar: hay {{count}} problema en el archivo, marcado en rojo.",
        motivoErrores_plural: "No se puede importar: hay {{count}} problemas en el archivo, marcados en rojo.",
        motivoVacio: "El archivo no tiene ningún precio para cargar.",
        motivoSinVigencia: "Falta indicar desde cuándo rige la lista.",
        cancelar: "Cancelar",
        guardar: "Guardar",
        cerrar: "Cerrar",
        historialAyuda: "La lista «En uso» es la que consulta el asistente. Un borrador no la reemplaza hasta que lo activás.",
        borradoresTitulo: "Hay {{count}} lista en borrador sin activar",
        borradoresTitulo_plural: "Hay {{count}} listas en borrador sin activar",
        borradoresAyuda: "El asistente sigue usando «{{vigente}}». Revisá el borrador y activalo cuando esté listo.",
        borradoresAyudaSinVigente: "Todavía no hay una lista en uso: el asistente no da precios hasta que actives una.",
        borradorDetalle: "{{n}} precios · importada el {{fecha}}",
        verPrecios: "Ver precios",
        probar: "Probar",
        activar: "Activar",
        viendoLista: "Estás viendo «{{lista}}» ({{estado}}). No es la lista que usa el asistente.",
        volverAVigente: "Volver a la lista en uso",
        activarTitulo: "Activar «{{lista}}»",
        activarFrase: "La lista «{{nueva}}» pasa a ser la que usa el asistente. La actual «{{actual}}» queda archivada.",
        activarFraseSinVigente: "La lista «{{nueva}}» pasa a ser la que usa el asistente.",
        activarColVigente: "En uso ahora",
        activarColNueva: "La que entra",
        activarProbarAntes: "¿Dudás? Probala primero: consultá un vehículo real y compará lo que contestaría cada lista.",
        activarBoton: "Activar",
        activarError: "No se pudo activar la lista.",
        activada: "«{{lista}}» es ahora la lista que usa el asistente.",
        chipActivosCorto: "Con precio",
        incidencias: "Incidencias del import",
        incNinguna: "Ninguna",
        incNoRegistradas: "No registradas",
        incNoRegistradasAyuda: "Esta lista se importó antes de que se guardaran las incidencias. Si querés verlas, volvé a elegir el mismo archivo en Importar (el preview no guarda nada).",
        incQuedaronAfuera: "{{count}} celda quedó afuera",
        incQuedaronAfuera_plural: "{{count}} celdas quedaron afuera",
        borrarTitulo: "Borrar lista",
        borrarFrase: "Se borra «{{lista}}» con sus {{n}} precios. No se puede deshacer. La lista en uso no cambia.",
        borrarBoton: "Borrar",
        borrarError: "No se pudo borrar la lista.",
        borrada: "Se borró «{{lista}}».",
        importadaBorrador: "«{{lista}}» quedó en borrador. Activala cuando la hayas revisado.",
        importadaVigente: "La lista nueva ya está en uso.",
        probarTitulo: "Probar «{{lista}}»",
        probarAyuda: "Hacé la misma consulta que haría el asistente con un cliente real.",
        probarAyudaComparar: "Hacé la misma consulta que haría el asistente, y compará con lo que contesta hoy «{{vigente}}».",
        probarVehiculo: "Vehículo",
        probarRango: "año",
        probarUltimoService: "Último service (km)",
        probarKmActual: "Km actual",
        probarItemOpcional: "Adicional (opcional)",
        probarConsultar: "Consultar",
        probarError: "No se pudo hacer la consulta.",
        probarEsta: "«{{lista}}»",
        probarEnUso: "En uso: «{{lista}}»",
        probarModelo: "Modelo",
        probarItem: "Ítem",
        probarServiceQueToca: "Service que corresponde: {{km}} km",
        probarAtrasado: "Viene atrasado {{km}} km",
        probarFalta: "Le falta el dato: {{dato}}",
        probarRes_precio: "Da precio",
        probarRes_no_aplica: "No aplica a ese vehículo",
        probarRes_modelo_ambiguo: "Pregunta cuál es el modelo",
        probarRes_item_ambiguo: "Pregunta cuál es el adicional",
        probarRes_anio_faltante: "Pregunta el {{eje}}",
        probarRes_anio_sin_cobertura: "No hay precio para ese {{eje}} → deriva",
        probarRes_falta_dato: "Pregunta un dato que falta",
        probarRes_km_incoherentes: "Los km no cierran (el actual es menor que el del último service) → lo aclara con el cliente",
        probarRes_sin_dato: "No encuentra precio → deriva a un asesor",
        probarRes_fuera_de_grilla: "Kilometraje fuera de la lista → deriva",
        probarRes_salteo_intervalos: "Se salteó services → deriva",
        probarRes_lista_vencida: "Lista vencida → deriva sin precio",
        probarRes_sin_lista: "Sin lista → deriva",
      },
      servicios: {
        titulo: "Servicios",
        tituloSeccion: "Servicios",
        nuevo: "Agregar {{service}}",
        editar: "Editar {{service}}",
        activo: "Activo",
        inactivo: "Inactivo",
        activar: "Activar",
        desactivar: "Desactivar",
        cualquiera: "Cualquiera",
        nombre: "Nombre *",
        duracion: "Duración (minutos)",
        profesionalAsignado: "Quién lo atiende",
        guardar: "Guardar",
        cancelar: "Cancelar",
        tooltipEditar: "Editar",
        headerNombre: "Nombre",
        headerDuracion: "Duración",
        headerEntrega: "Entrega",
        headerPrecio: "Precio",
        precio: "Precio",
        helperPrecio: "Opcional. En la moneda de tu país — no hace falta aclararla.",
        helperDuracion: "Lo que ocupa en la agenda (el paso de la grilla de horarios).",
        entrega: "Tiempo de entrega (minutos)",
        helperEntrega: "Opcional. Cuándo se entrega el trabajo terminado. No ocupa agenda: es lo que el asistente le dice al cliente.",
        descripcion: "Descripción",
        helperDescripcion: "Opcional. Se la mostramos {{alPatient}} y ayuda al asistente a entender de qué {{service}} le hablan.",
        headerProfesional: "Profesional",
        headerEstado: "Estado",
        headerAcciones: "Acciones",
        agregarBtn: "Agregar",
        sinServicios: "Todavía no cargaste {{servicePlural}}.",
        borrar: "Eliminar definitivamente",
        borrarTitulo: "Eliminar {{service}}",
        borrarTexto: "Se elimina «{{name}}» de la lista, para siempre. Desactivarlo lo saca de circulación pero lo deja en el historial; esto no.",
        borrarConfirmar: "Eliminar",
        borrarCancelar: "Cancelar",
        borrarOk: "Listo, quedó eliminado",
        borrarEnUso: "No se puede eliminar: tiene {{count}} {{appointmentPlural}} en su historial. Solo puede desactivarse.",
        borrarEnUsoOtros: "No se puede eliminar: está en uso en otras partes del sistema. Solo puede desactivarse.",
        borrarError: "No se pudo eliminar",
      },
      agendadores: {
        titulo: "Agendadores",
        tituloSeccion: "Secretarias",
        descripcion: "Quiénes cargan {{appointmentPlural}} a mano, sobre {{losProfessionalPlural}} que les correspondan. También pueden habilitar sobreturnos en días puntuales.",
        nuevo: "Agregar {{scheduler}}",
        editar: "Editar {{scheduler}}",
        activo: "Activo",
        inactivo: "Inactivo",
        activar: "Activar",
        desactivar: "Desactivar",
        nombre: "Nombre *",
        email: "Email",
        emailReq: "Email *",
        passwordReq: "Contraseña *",
        nuevaPassword: "Nueva contraseña (opcional)",
        helperPassword: "Dejar vacío para no cambiar",
        guardar: "Guardar",
        cancelar: "Cancelar",
        tooltipEditar: "Editar",
        errorNombre: "El nombre es requerido",
        errorCredenciales: "Email y contraseña son requeridos",
        errorEmailOtroPerfil: "Ese email ya pertenece a un usuario con perfil {{perfil}} de la empresa. Usá otro email: la contraseña que tipeaste no se aplica a un usuario que ya existe.",
        errorGuardar: "No se pudo guardar. Probá de nuevo.",
        usuarioReutilizado: "Ese usuario ya existía en WAIA: entra con su contraseña anterior, la que tipeaste no se aplicó.",
        perfil: {
          admin: "administrador",
          user: "usuario",
          profesional: "profesional",
          agendador: "agendador",
          desconocido: "desconocido",
        },
        headerNombre: "Nombre",
        headerEmail: "Email",
        headerProfesionales: "Profesionales asignados",
        headerEstado: "Estado",
        headerAcciones: "Acciones",
        agregarBtn: "Agregar",
        sinAgendadores: "Todavía no cargaste {{schedulerPlural}}.",
        sinAsignacion: "Sin asignación",
        profesionalesLabel: "Profesionales asignados",
        noProfesionales: "Todavía no hay {{professionalPlural}} disponibles.",
      },
      recordatorios: {
        titulo: "Recordatorios",
        tipo: "Tipo",
        estado: "Estado",
        pendiente: "Pendiente",
        enviado: "Enviado",
        fallido: "Fallido",
        respondido: "Respondido",
        saltado: "Saltado",
        todosLosTipos: "Todos los tipos",
        todosLosEstados: "Todos los estados",
        historial: "Historial de recordatorios",
        seguimiento: "Seguimiento de los recordatorios enviados. El sistema los manda solo, según la configuración de la empresa.",
        paciente: "Paciente",
        programadoPara: "Programado para",
        vistaPrev: "Vista previa",
        noHayRegistros: "No hay recordatorios registrados",
        sinDatos: "Sin datos de recordatorios disponibles",
        confirmacionReserva: "Confirmación de reserva",
        recordatorioSimple: "Recordatorio",
        solicitudConfirmacion: "Solicitud confirmación",
        ofertaRebalanceo: "Oferta rebalanceo",
        ofertaListaEspera: "Oferta lista espera",
      },
      configuracion: {
        titulo: "Configuración de disponibilidad",
        horariosAtencion: "Horarios de atención",
        agregarHorario: "Agregar horario",
        dia: "Día",
        desde: "Desde",
        hasta: "Hasta",
        acciones: "Acciones",
        sinHorarios: "Sin horarios configurados",
        cupoVentana: "Tope de la franja",
        cupoVentanaAyuda: "Opcional. Vacío = sin tope. Cuántos turnos acepta esta franja; acota al asistente, no al panel.",
        editar: "Editar",
        editarHorario: "Editar horario",
        bloqueosAgenda: "Bloqueos de agenda",
        agregarBloqueo: "Agregar bloqueo",
        motivo: "Motivo",
        sinBloqueos: "Sin bloqueos",
        eliminar: "Eliminar",
        diaSemana: "Día de la semana",
        horaInicio: "Hora inicio",
        horaFin: "Hora fin",
        fechaHoraInicio: "Fecha/hora inicio",
        fechaHoraFin: "Fecha/hora fin",
        motivoOpcional: "Motivo (opcional)",
        cancelar: "Cancelar",
        guardar: "Guardar",
      },
      listaEspera: {
        titulo: "Lista de Espera",
        descripcion: "Quiénes pidieron un lugar y no encontraron disponibilidad. Les avisamos automáticamente si se libera algo compatible.",
        tituloLista: "Lista de espera",
        profesional: "Profesional",
        servicio: "Servicio",
        estado: "Estado",
        cualquiera: "Cualquiera",
        todos: "Todos",
        tooltipEliminar: "Eliminar de la lista",
        enEspera: "En espera",
        ofertaEnviada: "Oferta enviada",
        confirmado: "Confirmado",
        expirado: "Expirado",
        eliminado: "Eliminado",
        pendiente: "Pendiente",
        enCurso: "En curso",
        completado: "Completado",
        fallido: "Fallido",
        abandonado: "Abandonado",
        listaEspera: "Lista de espera",
        adelantamiento: "Adelantamiento",
        eliminar: "Eliminar",
        cancelar: "Cancelar",
        headerPaciente: "Paciente",
        headerProfesional: "Profesional",
        headerServicio: "Servicio",
        headerPedido: "Día/hora pedido",
        sinPreferencia: "Sin preferencia",
        headerIngreso: "Ingresó",
        headerVence: "Vence",
        headerEstado: "Estado",
        headerAcciones: "Acciones",
        noHayPacientes: "No hay nadie esperando.",
        enEsperaCount: "{{count}} en espera",
        historialRebalanceos: "Historial de rebalanceos",
        histHeaderId: "ID",
        histHeaderTurno: "Hueco liberado",
        histHeaderProfesional: "Profesional",
        histHeaderEstado: "Estado",
        histHeaderFase: "Fase",
        histHeaderIntentos: "Intentos",
        histHeaderIniciado: "Iniciado",
        sinHistorial: "Sin historial de rebalanceos",
        eliminarDialogTitle: "Eliminar de lista de espera",
        confirmarEliminar: "¿Confirmar que deseas eliminar a",
        estePaciente: "esta persona",
        deListaEspera: "de la lista de espera? Esta acción no se puede deshacer.",
      },
      identificadorContacto: {
        title: "Identificador del contacto",
        help: "El dato que identifica lo que el contacto trae —la patente en un taller, el nombre del animal en una veterinaria, el número de serie en un service técnico—. Se muestra al lado del nombre en el chat y en la ficha del contacto. Si hay más de una clave, se usa la primera que tenga valor.",
        clave: "Clave de la ficha",
        etiqueta: "Etiqueta",
        fichas: "{{n}} fichas con dato",
        agregar: "Agregar clave",
        quitar: "Quitar",
        guardar: "Guardar",
        guardado: "Identificador guardado",
        sinFichas: "Todavía no hay fichas cargadas: las claves aparecen cuando entra la primera campaña. Podés escribir la clave igual.",
        vacio: "Sin identificador: no se muestra nada junto al nombre.",
        max: "Máximo 3 claves.",
      },
      ajustes: {
        voiceTemplateDefault: "{nombre}, pasá a {consultorio}, con {profesional}. Repito: {nombre}, pasá a {consultorio}.",
        salaProfesionales: "{{professionalPlural_c}} (vacío = sin filtrar)",
        salaSoloInicial: "Mostrar solo la inicial del apellido",
        salaDing: "Ding dong en cada llamado",
        salaVoz: "Anuncio de voz",
        salaProximos: "Mostrar quiénes siguen",
        salaAnteriores: "Mostrar quiénes ya pasaron",
        nombreNegocio: "Nombre del negocio",
        nombreNegocioPlaceholder: "Ej: Taller Junín, Consultorio Gazzera",
        grupoAgendaVentana: "Agenda → Ventana de reserva",
        dias: "días",
        metaEnRevision: "En revisión",
        metaNoCreada: "No creada",
        metaDentro24: "dentro de las 24 horas",
        metaNoRequieren: "no requieren aprobación de Meta",
        metaAprobada: "plantilla aprobada por Meta",
        metaSoloLectura: "solo lectura",
        solicitudConfirmacion: "Solicitud de confirmación",
        opModoTitle: "Modo de operación",
        opModoDesc: "Define qué hace la IA cuando no puede resolver algo y a quién le llega el caso.",
        opModoActivo: "Actual",
        opModoLocked: "Disponible en un plan superior — contactanos para activarlo",
        opEffectiveLabel: "A quién le llegan hoy los casos:",
        opGuardarModo: "Guardar modo",
        opDestinatarioChat: "+ chat de WhatsApp",
        opModo: {
          desatendido: {
            title: "Desatendido",
            desc: "La IA atiende sola. Si no puede resolver algo, deja el caso para que lo veas en tu agenda. No promete atención humana en vivo.",
          },
          atendido: {
            title: "Atendido",
            desc: "La IA atiende; los casos que no puede resolver van a la secretaria / agendador.",
          },
          con_chat: {
            title: "Con chat",
            desc: "Además, tu equipo puede atender por el chat de WhatsApp. La IA puede derivar a una persona.",
          },
        },
        opDestinatario: {
          profesionales: "Los profesionales (cada caso aparece en la agenda del profesional del turno)",
          rol: "La secretaria / agendador",
          usuario: "Un usuario designado",
          admin: "El administrador",
        },
        grupoAsistente: "Asistente",
        // ── Interruptor de la IA ──────────────────────────────────────────
        // El texto dice qué hace Y qué NO hace: apagar la IA no apaga los
        // recordatorios, y esa confusión deja a una empresa sin producto.
        iaOn: "El asistente responde los mensajes entrantes",
        iaOff: "El asistente NO responde: atiende una persona",
        iaDesc: "Con el asistente apagado, los mensajes que entran no se le pasan a la IA: quedan en la bandeja de Chats para que los atienda una persona. Es un modo de operación, no un modo de mantenimiento — podés dejarlo apagado todo el tiempo que quieras.",
        iaNoApagaRecordatorios: "⛔ Apagar el asistente NO apaga los recordatorios: los avisos programados, las confirmaciones de reserva y las campañas salientes se siguen enviando igual.",
        iaUltimoCambio: "Último cambio:",
        iaPorUsuario: "por el usuario",
        iaPrendidaOk: "El asistente vuelve a responder los mensajes entrantes.",
        iaApagadaOk: "Asistente apagado. Los mensajes entrantes quedan en la bandeja. Los recordatorios siguen saliendo.",
        // ── Gate de superadmin sobre el asistente (feat_369) ──────────────
        // El switch se VE, deshabilitado y con el motivo. Esconderlo genera un
        // llamado; un control gris que dice por qué se entiende solo.
        iaNoHabilitada: "El asistente no está habilitado para tu cuenta",
        iaNoHabilitadaDesc: "Esta función no está habilitada para tu cuenta. Escribinos si la querés activar.",
        // ── Interruptor de los recordatorios ──────────────────────────────
        // Dice qué apaga Y qué NO: la confirmación al crear un turno sigue
        // saliendo, y esa confusión deja a una empresa creyendo que rompió algo.
        remTitle: "Avisos programados",
        remOn: "Los avisos programados salen",
        remOff: "Los avisos programados NO salen",
        remDesc: "Los pasos que tengas configurados abajo (30 días antes, 24 horas antes, etc.). Cada aviso es un mensaje de plantilla de WhatsApp y tiene costo. Apagarlos no borra nada: al volver a prenderlos, la cola retoma donde estaba.",
        remNoApagaConfirmacion: "⛔ Apagar los avisos programados NO apaga la confirmación que sale al crear un turno (ésa la controla la opción \"notificar\" del turno) ni las campañas salientes.",
        remNoHabilitados: "Los avisos programados no están habilitados para tu cuenta",
        remNoHabilitadosDesc: "Esta función no está habilitada para tu cuenta. Escribinos si la querés activar.",
        remPrendidosOk: "Los avisos programados vuelven a salir. La cola retoma donde estaba.",
        remApagadosOk: "Avisos programados apagados. La confirmación al crear un turno sigue saliendo.",
        asistenteTitle: "Asistente y datos de la empresa",
        asistenteDesc: "Configurá el nombre y el tono del asistente, y los datos que responde a {{losPatientPlural}}.",
        asistenteNombre: "Nombre del asistente",
        asistenteNombrePlaceholder: "Ej: SofIA",
        asistenteTono: "Tono",
        tonoCordial: "Cordial",
        tonoFormal: "Formal",
        tonoInformal: "Informal",
        asistenteInfoEmpresa: "Información de la empresa",
        asistenteInfoAyuda: "El asistente usa estos datos para responder consultas (dónde están, horarios, {{coberturaPlural}}, etc.). Lo que no esté acá y no sea sobre la agenda, no lo inventa.",
        infoDireccion: "Dirección",
        infoDireccionPlaceholder: "Ej: Av. Colón 1234, Nueva Córdoba",
        infoTelefono: "Teléfono",
        infoTelefonoPlaceholder: "Ej: 0351-1234567",
        infoHorarios: "Horarios de atención",
        infoHorariosPlaceholder: "Ej: Lun a Vie 9 a 18hs",
        infoComoLlegar: "Cómo llegar",
        infoComoLlegarPlaceholder: "Ej: a media cuadra de la plaza, entrada por el pasillo",
        infoObrasSociales: "{{coberturaPlural_c}}",
        infoObrasSocialesPlaceholder: "Ej: PAMI, OSDE, particular (o 'no trabajamos con {{cobertura}}')",
        vocab: {
          title: "Vocabulario",
          desc: "Estas palabras se usan en todo el sistema y también en los mensajes que el asistente manda. Se heredan del rubro; editá sólo lo que quieras cambiar.",
          rubroChip: "Rubro",
          plural: "Plural",
          propio: "Valor propio",
          heredado: "Heredado",
          restaurar: "Restaurar valores del rubro",
          restaurado: "Vocabulario restaurado a los valores del rubro",
          scheduler: "Quien agenda (mostrador)",
          room: "Consultorio / box",
          generoTitulo: "el / la",
          generoAyuda: "Marcá si la palabra es masculina o femenina. Sirve para que el sistema escriba bien el artículo (\"la Sucursal\", no \"el Sucursal\") en todas las pantallas.",
          generoM: "el",
          generoF: "la",
          patient: "Persona atendida",
          professional: "Profesional",
          appointment: "Turno / cita",
          specialty: "Especialidad",
          service: "Servicio",
          waitingRoom: "Sala de espera",
          cobertura: "Cobertura (obra social / seguro)",
          patientName: "Campo: Nombre",
          patientPhone: "Campo: Teléfono",
        },
        infoFormasPago: "Formas de pago",
        infoFormasPagoPlaceholder: "Ej: efectivo, débito, transferencia",
        infoAdicional: "Información adicional",
        infoAdicionalPlaceholder: "Cualquier otro dato que el asistente deba saber para responder",
        grupoGeneral: "General",
        grupoRecordatorios: "Recordatorios",
        grupoAgenda: "Agenda",
        grupoPermisos: "Permisos y panel",
        rwTitle: "Ventana de envío de recordatorios",
        rwDesc: "Franja horaria y días en los que se permiten enviar recordatorios.",
        rwInheritedBadge: "Heredado",
        rwOwnBadge: "Configuración propia",
        rwInheritedFrom: "Esta empresa usa el default global de TurnosIA. Valor efectivo:",
        rwEffectivePreview: "Valor efectivo",
        rwHoraDesde: "Hora desde",
        rwHoraHasta: "Hora hasta",
        rwDiasEvitar: "Días a evitar",
        rwSabadoHasta: "Sábado hasta",
        rwSabadoPropio: "Sábado con horario propio",
        rwUsarPropia: "Usar configuración propia",
        rwVolverHeredar: "Volver a heredar",
        rwGuardar: "Guardar ventana",
        rwHelp: "Los recordatorios que caerían fuera de esta franja o en un día evitado se corren al momento válido más cercano anterior.",
        rwOkGuardado: "Ventana de envío guardada",
        rwOkHeredar: "Volvió a heredar el default global",
        rwDia_dom: "Dom",
        rwDia_lun: "Lun",
        rwDia_mar: "Mar",
        rwDia_mie: "Mié",
        rwDia_jue: "Jue",
        rwDia_vie: "Vie",
        rwDia_sab: "Sáb",
        activar: "Activar",
        configuracionGeneral: "Configuración general",
        parametrosDesc: "Parámetros de integración y comportamiento del módulo.",
        urlWebhookN8n: "Webhook de n8n (TurnosIA)",
        urlWebhookN8nHelp: "Los mensajes que entren por la línea de TurnosIA se envían a este webhook.",
        webhookConfigured: "Configurado",
        webhookNotConfigured: "Sin configurar",
        webhookManagedBySuperadmin: "Lo administra el equipo (panel superadmin).",
        guardarConfig: "Guardar configuración",
        secuenciaRecordatorios: "Secuencia de recordatorios",
        secuenciaDesc: "Cuándo y qué tipo de mensaje se envía antes. Sólo puede haber un pedido de confirmación por cada {{appointment}}.",
        headerOrden: "Orden",
        headerHorasAntes: "Horas antes",
        headerTipo: "Tipo",
        headerActivo: "Activo",
        headerAcciones: "Acciones",
        sinPasos: "Sin pasos configurados",
        plantillasMensajes: "Plantillas de mensajes",
        plantillasDesc: "Textos que se envían en cada situación. Variables disponibles:",
        guardarPlantilla: "Guardar",
        especialidades: "{{specialtyPlural_c}}",
        especialidadesDesc: "Con qué se clasifica a quienes atienden. Podés agregar, editar o desactivar.",
        sinEspecialidades: "Todavía no cargaste {{specialtyPlural}}.",
        cancelarEspecialidad: "Cancelar",
        agregarEspecialidad: "Agregar {{specialty}}",
        cfTitle: "Campos personalizados",
        cfDesc: "Campos extra que se piden al cargar (ej. Patente, Notas). Los define tu empresa.",
        cfAdd: "Agregar campo",
        cfEmpty: "Sin campos personalizados configurados",
        cfColLabel: "Etiqueta",
        cfColType: "Tipo",
        cfColRequired: "Requerido",
        cfColCalendar: "En calendario",
        cfCalendarHelp: "Se muestra en la tarjeta del turno del calendario, antes del nombre (ej. la patente). Máximo 2 campos.",
        cfColOrder: "Orden",
        cfEdit: "Editar campo",
        cfNew: "Nuevo campo personalizado",
        cfKeyLabel: "Clave (key)",
        cfKeyHelp: "Identificador estable, sin espacios. No se puede cambiar después.",
        cfOptionsLabel: "Opciones (separadas por coma)",
        cfOptionsHelp: "Ej: Rojo, Verde, Azul",
        cfErrorLabel: "La etiqueta es requerida",
        cfErrorKey: "La clave es requerida",
        cfErrorOptions: "Las opciones son requeridas para tipo lista",
        cfType_text: "Texto",
        cfType_textarea: "Texto largo",
        cfType_number: "Número",
        cfType_date: "Fecha",
        cfType_select: "Lista",
        tplTitle: "Aplicar plantilla de rubro",
        tplDesc: "Suma especialidades, campos y términos del rubro elegido. No pisa lo que ya editaste.",
        tplSelectLabel: "Rubro",
        tplSelectPlaceholder: "Seleccionar...",
        tplApply: "Aplicar plantilla",
        tplCurrent: "Rubro actual",
        tplName_generico: "Genérico",
        tplName_odontologia: "Odontología",
        tplName_taller: "Taller",
        tplConfirmTitle: "¿Aplicar plantilla?",
        tplConfirmBody: "Suma especialidades, campos personalizados y terminología del rubro. No pisa lo que ya editaste.",
        tplAplicada: "Plantilla aplicada",
        outgoingTitle: "Línea de TurnosIA",
        outgoingDesc: "Número dedicado a TurnosIA. Se usa para enviar recordatorios y para recibir las conversaciones del asistente.",
        outgoingLabel: "Línea de TurnosIA",
        outgoingDefault: "Usar la conexión predeterminada",
        outgoingEmpty: "No hay conexiones de WhatsApp en esta empresa.",
        outgoingHint: "Se recomienda un número QR: los avisos de TurnosIA son texto libre.",
        outgoingMetaWarn: "META requiere plantilla aprobada. Los avisos de TurnosIA son texto libre — elegí un número QR.",
        lineStatusFree: "Libre",
        lineStatusCurrent: "Línea actual de TurnosIA",
        lineStatusCompanyBot: "En uso por el bot de la empresa",
        lineStatusOtherBot: "En uso por otro bot (webhook propio)",
        lineOccupiedTitle: "Esta línea ya está en uso",
        lineOccupiedCompanyBot: "Esta línea hoy atiende al bot de la empresa. Si la asignás a TurnosIA, los mensajes que entren por ella dejarán de ir a ese bot.",
        lineOccupiedOtherBot: "Esta línea hoy la usa otro bot (tiene su propio webhook). Si la asignás a TurnosIA, dejará de recibir esos mensajes.",
        lineOccupiedConfirm: "Asignar igual",
        lineOccupiedCancel: "Cancelar",
        textoPara: "Texto para",
        salasEspera: "{{waitingRoomPlural_c}}",
        salasDesc: "Las pantallas que ve quien espera. Cada una puede mostrar a quienes vos elijas.",
        agregarSala: "Agregar sala",
        sinSalas: "Sin salas configuradas.",
        todosProfesionales: "Sin filtrar",
        featureNoHabilitada: "Esta función no está habilitada para tu empresa. Contactá al administrador para activarla.",
        templateBookingConfirmed: "Confirmación de reserva",
        templateAppointmentRescheduled: "Aviso de reprogramación",
        templateReminder: "Recordatorio simple",
        templateConfirmationRequest: "Solicitud de confirmación",
        templateRebalanceOffer: "Oferta de rebalanceo",
        templateWaitinglistOffer: "Oferta desde lista de espera",
        templateCancellationConfirmed: "Aviso de cancelación",
        templateWaitinglistAdded: "Agregado a lista de espera",
        templateLlamarSiguiente: "Te toca (llamar al siguiente)",
        templateArrivalCheck: "¿Estás llegando? (turno empezado sin llegada)",
        arrivalTitle: "Consulta de llegada",
        arrivalHelp: "Si un turno confirmado empezó hace unos minutos y nadie marcó «Llegó» en la agenda, se le pregunta al cliente si está llegando. Si responde que ya está, el asistente registra la llegada. Respeta el interruptor de avisos programados.",
        arrivalSwitch: "Preguntar «¿estás llegando?»",
        arrivalMinutes: "Minutos después del inicio del turno",
        arrivalMinutesHelp: "Entre 5 y 120. Vacío = 10.",
        arrivalWarn: "⚠ Si el mostrador no marca «Llegó», el mensaje le puede llegar a quien ya está en el local.",
        errorSoloUnaConfirmacion: "Sólo puede haber un pedido de confirmación por cada {{appointment}}.",
        errorNombreRequerido: "El nombre es requerido",
        errorGuardar: "Error al guardar",
        errorDesactivar: "No se pudo desactivar",
        errorSlugRequerido: "Nombre y slug son requeridos",
        slugEmpresa: "Identificador de empresa (slug)",
        helperSlug: "Sin espacios ni caracteres especiales",
        idDepartamento: "ID departamento WAIA",
        helperDepartamento: "Para derivar tickets a este departamento",
        rebalanceoAuto: "Activar rebalanceo automático al cancelar turnos",
        tiempoRespuesta: "Tiempo de respuesta oferta (minutos)",
        helperTiempoRespuesta: "Minutos para que el candidato acepte una oferta",
        diasListaEspera: "Días en lista de espera",
        helperDiasLista: "Días que alguien permanece en la lista",
        ventanaAdelantamiento: "Ventana de adelantamiento (días)",
        helperVentana: "Días hacia adelante para buscar candidatos",
        exclusionCancelar: "Exclusión tras cancelar (horas)",
        helperExclusion: "Horas de exclusión anti-loop",
        duracionEsperada: "Duración esperada, en minutos",
        helperDuracion: "Se aplica cuando la consulta no indica {{unService}}. Orden: la del {{service}} elegido; si no hay {{service}}, ésta; si ésta queda vacía, 30 minutos. También sirve para calcular si se va adelantado o atrasado.",
        vrTitle: "Ventana de reserva",
        vrDesc: "Hasta cuándo hacia adelante se pueden dar {{appointmentPlural}}, y desde cuándo puede darlos el asistente por WhatsApp.",
        vrTechoLabel: "Con cuánta anticipación se puede reservar",
        vrTechoHelp: "Máximo hacia adelante. Vale para el panel y para el asistente por igual. Entre {{min}} y {{max}}.",
        vrUnitLabel: "Unidad",
        vrUnitDays: "días",
        vrUnitMonths: "meses",
        vrPisoLabel: "Mínimo de anticipación (solo por WhatsApp)",
        vrPisoHelp: "Los próximos {{n}} días quedan reservados para quien llama por teléfono o se acerca; el asistente no los ofrece, pero desde acá seguís pudiendo agendarlos.",
        vrPisoHelpZero: "Sin mínimo: el asistente puede ofrecer {{appointmentPlural}} para hoy mismo. Poné un número de días para reservarle los primeros días a quien llama por teléfono o se acerca.",
        vrConfirmSkipLabel: "No pedir confirmación si lo sacó por WhatsApp con menos de N días",
        vrConfirmSkipHelp: "Si {{elPatient}} lo sacó por WhatsApp y faltan menos de {{n}} días, no se pregunta si confirma: lo acaba de elegir. Vacío = {{n}} días.",
        vrConfirmSkipOff: "0 = siempre se pide confirmación, aunque {{elPatient}} lo haya sacado por WhatsApp hace un rato.",
        vrBotSlotLimitLabel: "Horarios que recibe el asistente por consulta",
        vrBotSlotLimitHelp: "El asistente elige entre los {{n}} primeros horarios de cada consulta. Si tenés varias sucursales o sedes, con pocos se llena con los primeros horarios de la mañana y la tarde no le llega. Vacío = 20.",
        pideConfirmacion: "Pide confirmación",
        recordatorio: "Recordatorio",
        si: "Sí",
        no: "No",
        editar: "Editar",
        eliminar: "Eliminar",
        editarEspecialidad: "Editar {{specialty}}",
        nuevaEspecialidad: "Agregar {{specialty}}",
        nombreEspecialidad: "Nombre",
        guardarEspecialidad: "Guardar",
        activa: "Activa",
        inactiva: "Inactiva",
        editarNombre: "Editar nombre",
        desactivar: "Desactivar",
        editarSala: "Editar sala",
        nuevaSala: "Agregar {{waitingRoom}}",
        nombreSala: "Nombre *",
        slugSala: "Slug *",
        helperSlugSala: "Solo minúsculas y guiones. Ejemplo: sala-principal",
        plantillaVoz: "Plantilla de voz",
        helperVoz: "Variables: {nombre} {consultorio} {profesional}",
        guardarSala: "Guardar",
        copiarUrl: "Copiar URL",
        sinLinkCorto: "Sin link corto",
        regenerarLink: "Regenerar y copiar link corto",
        generarLink: "Generar link corto",
        linkCopiado: "Link copiado",
        errorLink: "Error al generar el link corto",
        editarPaso: "Editar paso",
        agregarPaso: "Agregar paso",
        horasAntes: "Horas antes",
        tipoRecordatorio: "Tipo",
        activoSwitch: "Activo",
        guardarPaso: "Guardar",
        guardadoOk: "Guardado correctamente",
        permisosProfesional: "Permisos de quien atiende",
        permisosProfesionalDesc: "Qué puede hacer sobre su propia agenda, desde su calendario.",
        professionalCanCreate: "Puede cargar {{appointmentPlural}} en su propia agenda",
        professionalCanMove: "Puede reprogramar (mover o arrastrar) lo suyo",
        panelDeTurno: "Panel de detalle",
        panelDeTurnoDesc: "Qué acciones aparecen al abrir el detalle.",
        panelAction: {
          status: "Cambiar estado",
          move: "Mover",
          reAvisar: "Re-avisar por WhatsApp",
          cancelReason: "Cancelar con motivo",
          openChat: "Abrir el chat",
          history: "Historial",
          statusLog: "Registro de cambios de estado",
          waitingRoom: "Llamar ({{waitingRoom}})",
          followUp: "Seguimiento",
          note: "Notas",
          showPhone: "Mostrar teléfono",
          delete: "Eliminar",
        },
        localizacion: "Localización",
        localizacionDesc: "Zona horaria e idioma de fechas/horas para toda la empresa.",
        timezone: "Zona horaria",
        locale: "Idioma de fechas",
      },
      internalChat: {
        placeholder: "Escribir mensaje...",
        para: "Para",
        todos: "Todos",
        chatInterno: "Chat interno",
        mediaTooLarge: "Los archivos superan el límite de 18 MB. Enviá menos a la vez.",
        quotedNotLoaded: "El mensaje citado ya no está cargado en esta conversación.",
        jumpToQuoted: "Ir al mensaje citado",
      },
      salaEspera: {
        cargando: "Cargando…",
        errorConexion: "No se pudo conectar con el servicio.",
        fallbackNombre: "{{waitingRoom_c}}",
        enAtencion: "⬤ En atención ahora",
        aguardando: "Aguardando el llamado…",
        proximosTurnos: "A continuación",
        sinProximos: "No hay nadie esperando",
        yaAtendidos: "Ya pasaron",
        sinPrevios: "Todavía no pasó nadie hoy",
        linkNoEncontrado: "No encontramos esa pantalla",
        llamado: "Llamado",
        enAtencionCard: "En atención",
        min: "min",
      },
      sidebar: {
        empresas: "Empresas",
        dashboardAdmin: "Dashboard",
        comunicados: "Comunicados",
        logsDelSistema: "Logs del sistema",
        avisos: "Avisos",
        apis: "APIs",
        turnosIA: "TurnosIA",
        citas: "Citas",
        changelog: "Changelog",
        turnos: "TurnosIA",
        pendientes: "Pendientes",
        estadisticas: "Estadísticas",
        reportes: "Reportes",
        etiquetas: "Etiquetas",
        estadosDeContacto: "Estados de Contacto",
        matchprop: "MatchProp",
        aiServices: "Servicios IA",
        aiStats: "Estadísticas IA",
        connectionsOverview: "Conexiones (global)",
      },
      superAdminConnections: {
        title: "Conexiones por empresa",
        subtitle: "Estado de todas las conexiones de WhatsApp y salud de las líneas Meta, en todas las empresas.",
        refresh: "Actualizar",
        semaphoreSection: "Semáforo de conexiones",
        semaphoreHelp: "Resumen por empresa. Verde: todas conectadas. Amarillo: reconectando o caída parcial. Rojo: caída sin conexión activa. Gris: sin conexiones.",
        company: "Empresa",
        state: "Estado",
        total: "Total",
        connected: "Conectadas",
        transitional: "En transición",
        down: "Caídas",
        lastChange: "Último cambio",
        semaphore: {
          green: "Operativa",
          yellow: "Atención",
          red: "Caída",
          none: "Sin conexiones",
        },
        metaSection: "Líneas Meta",
        metaHelp: "Salud de cada línea de WhatsApp Cloud API / Coexistencia.",
        metaEmpty: "No hay líneas Meta configuradas.",
        line: "Línea",
        type: "Tipo",
        coexistence: "Coexistencia",
        phoneNumberId: "Phone Number ID",
        wabaId: "WABA ID",
        status: "Estado",
        health: "Salud",
        historySync: {
          title: "Historial",
          attempts: "{{count}} intento(s)",
          requestedAt: "Alta: {{date}}",
          nextAt: "Próximo reintento: {{date}}",
          lastError: "Último error: {{error}}",
          notSharedAt: "Aviso de Meta: {{date}}",
          status: {
            pending: "Pendiente",
            success: "Pedido OK",
            failed: "Falló",
            expired: "Vencido",
            skipped: "No pedido",
            not_shared: "El cliente no compartió el historial",
          },
        },
      },
      superAdminAI: {
        title: "Servicios IA — Configuración por empresa",
        subtitle: "Habilitá Servicios IA por empresa y cargá las claves de los proveedores (OpenAI, Anthropic, Gemini) como respaldo.",
        company: "Empresa",
        selectCompany: "Seleccionar empresa",
        enabled: "Habilitar Servicios IA",
        enabledHelp: "Activa el sector de Servicios IA para esta empresa. El administrador podrá configurar los servicios y sus claves.",
        keysSection: "Claves de los proveedores (respaldo)",
        keysHelp: "Las claves del administrador tienen prioridad. Estas son un respaldo opcional.",
        providerEnabled: "habilitado",
        apiKey: "Clave de {{provider}}",
        keyConfigured: "•••• (configurada)",
        keyNotSet: "Sin configurar",
        save: "Guardar",
        saveOk: "Configuración guardada",
        showKey: "Ver clave",
        hideKey: "Ocultar clave",
      },
      aiServices: {
        title: "Servicios IA",
        notEnabled: "Servicios IA no está habilitado para tu empresa. Contactá a soporte.",
        transcriptLabel: "Transcripción",
        transcribeBtn: "Transcribir audio",
        transcribing: "Transcribiendo…",
        failedMsg: "No se pudo transcribir",
        retry: "Reintentar",
        consumptionWarning: "⚠ Los servicios de IA consumen tokens de tus claves. Cada uso (por ejemplo, transcribir un audio) tiene costo en tu cuenta del proveedor.",
        keysSection: "Claves de IA",
        keysHelp: "Cargá tus propias claves por proveedor. Es tu gasto: las llamadas se cobran a estas claves.",
        apiKey: "Clave de {{provider}}",
        keyConfigured: "•••• (configurada)",
        keyNotSet: "Sin configurar",
        servicesSection: "Servicios",
        provider: "Proveedor",
        model: "Modelo",
        mode: "Modo",
        modeHuman: "Modo (atención humana)",
        aiAttendedMode: "Atención IA",
        aiAttendedSiempre: "Siempre transcribir",
        aiAttendedNunca: "Nunca transcribir",
        aiAttendedHelp: "Cuando la IA atiende el chat, define si el audio se pasa a texto para que la IA lo entienda.",
        limitSection: "Límite anti-abuso",
        limitHelp: "0 = sin límite. Aplica solo a la transcripción automática; el botón manual nunca se limita.",
        maxPerWindow: "Máx. audios por contacto",
        windowMinutes: "cada (minutos)",
        notSupported: "no soporta",
        transcribeProviderTip: "Anthropic no soporta transcripción de audio. Usá OpenAI o Gemini.",
        modes: {
          auto: "Automático (siempre)",
          a_pedido: "A pedido (manual)",
          nunca: "Nunca",
        },
        transcription: {
          title: "Transcripción de audio",
          help: "Convierte los audios entrantes en texto. Elegí proveedor, modelo y cuándo transcribir.",
        },
        save: "Guardar",
        saveOk: "Guardado",
        showKey: "Ver clave",
        hideKey: "Ocultar clave",
      },
      superAIStats: {
        title: "Estadísticas por Asistente IA — Configuración",
        company: "Empresa",
        selectCompany: "Elegí una empresa",
        enabled: "Módulo habilitado",
        enabledHelp:
          "Si está apagado, el módulo no aparece en el menú del admin ni sirve datos.",
        visibilityTitle: "Visibilidad de paneles",
        visibilityHelp:
          "Elegí qué paneles ve el cliente. Con el módulo apagado no se pueden configurar.",
        panels: {
          horasAhorradas: "Horas ahorradas",
          cobertura: "Cobertura 24/7",
          reclamosATiempo: "Reclamos a tiempo",
          iaVsHumano: "IA vs humano",
          recomendaciones: "Recomendaciones",
          embudoKpis: "Embudo y KPIs",
          objetoReclamo: "Objeto del reclamo",
          tags: "Etiquetas",
        },
        saveCompany: "Guardar empresa",
        saveOk: "Configuración guardada",
        saving: "Guardando…",
        assistantsTitle: "Asistentes",
        noAssistants: "Esta empresa aún no tiene asistentes.",
        catalogName: "Nombre en catálogo",
        displayName: "Nombre visible",
        type: "Tipo",
        types: {
          satisfaccion: "Satisfacción",
          venta: "Venta",
          recupero: "Recupero",
        },
        technicalConfig: "Configuración técnica",
        tech: {
          humanClosingHour: "Hora cierre humano",
          humanWorkMarginHours: "Margen trabajo (hs)",
          timeoutHours: "Timeout (hs)",
          sinRespuestaWarnPct: "Umbral sin respuesta (0-1)",
          queueRoles: "Roles de cola (JSON)",
          jsonFieldMap: "Mapa de campos (JSON)",
        },
        saveAssistant: "Guardar asistente",
        saveAssistantOk: "Asistente guardado",
        invalidJson: "JSON inválido en roles de cola o mapa de campos.",
      },
      superMatchProp: {
        title: "MatchProp — Configuración por empresa",
        subtitle: "Detector de pedidos de propiedades en grupos de WhatsApp. Configurá inventario, LLM y modo prueba por empresa.",
        company: "Empresa",
        selectCompany: "Seleccionar empresa",
        enabled: "Habilitar MatchProp",
        enabledHelp: "Activa el monitoreo de grupos y la generación de alertas para esta empresa.",
        dryRun: "Modo prueba (dry-run)",
        dryRunHelp: "En prueba, las alertas se ven con badge PRUEBA y no se considera envío real.",
        llmSection: "Modelo de lenguaje (LLM)",
        llmProvider: "Proveedor",
        llmModel: "Modelo",
        llmKey: "API key del LLM",
        inventorySection: "Inventario",
        inventorySource: "Fuente de inventario",
        tokkoKey: "API key de Tokko",
        gvaId: "ID Inmobiliaria (GVA)",
        gvaToken: "Token GVA",
        gvaHelp: "La credencial GVA (ID + token) la provee el proveedor, no el cliente.",
        ttlMinutes: "TTL de inventario (minutos)",
        keyConfigured: "•••• (configurada)",
        keyNotSet: "Sin configurar",
        lastSync: "Última sincronización",
        save: "Guardar",
        forceSync: "Forzar actualización ahora",
        saveOk: "Configuración guardada",
        syncOk: "Sincronizadas {{count}} propiedades",
        showKey: "Ver clave",
        hideKey: "Ocultar clave",
      },
      matchpropAdmin: {
        title: "MatchProp",
        notEnabled: "MatchProp no está habilitado para tu empresa. Contactá a soporte.",
        groupsSection: "Grupos a monitorear",
        groupsHelp: "Elegí qué grupos querés que MatchProp analice en busca de pedidos.",
        noGroups: "No hay grupos de WhatsApp conocidos todavía.",
        groupOn: "Grupo activado",
        groupOff: "Grupo desactivado",
        tolerancesSection: "Tolerancias de coincidencia",
        dormsPlus: "Dormitorios de más aceptados",
        dormsPlusHelp: "Aceptar propiedades con hasta X dormitorios MÁS que lo pedido.",
        dormsMinus: "Dormitorios de menos aceptados",
        dormsMinusHelp: "Aceptar propiedades con hasta X dormitorios MENOS que lo pedido.",
        precioMargin: "Margen de precio (%)",
        precioMarginHelp: "Aceptar propiedades hasta X% por encima del presupuesto.",
        topN: "Coincidencias por alerta",
        topNHelp: "Cuántas coincidencias mostrar en cada alerta.",
        minTopLevel: "Nivel mínimo para avisar",
        minTopLevelHelp: "EXACTO solo avisa coincidencias exactas; PARECIDO incluye aproximadas.",
        levelExact: "EXACTO",
        levelSimilar: "PARECIDO",
        save: "Guardar",
        saveOk: "Guardado",
        aiSection: "Inteligencia Artificial",
        llmProvider: "Proveedor de IA",
        llmModel: "Modelo",
        llmKey: "API key de IA",
        comingSoon: "próximamente",
        sourceSection: "Fuente de inventario",
        sourceLabel: "Fuente",
        sourceNotSet: "Tu proveedor aún no configuró la fuente de inventario.",
        crmKey: "API key del CRM",
        gvaId: "ID Inmobiliaria (GVA)",
        gvaToken: "Token GVA",
        gvaHelp: "Credencial provista por GVA.",
        keyConfigured: "•••• (configurada)",
        keyNotSet: "Sin configurar",
        showKey: "Ver clave",
        hideKey: "Ocultar clave",
        consumptionWarning: "⚠ Activá MatchProp solo en grupos de PEDIDOS de propiedades. Cada mensaje de un grupo monitoreado se analiza con IA y consume tokens de tu API. Activar grupos que no son de pedidos genera gasto innecesario.",
        confirmTitle: "Confirmar monitoreo del grupo",
        confirmBody: "El grupo \"{{group}}\" se analizará con IA en cada mensaje, consumiendo tus tokens. ¿Confirmás?",
        cancel: "Cancelar",
        confirm: "Activar",
      },
      tags: {
        titulo: "Etiquetas",
        nueva: "Nueva etiqueta",
        creada: "Etiqueta creada",
        eliminada: "Etiqueta eliminada",
        nombre: "Nombre",
        color: "Color",
        vistaPrevia: "Vista previa",
        cancelar: "Cancelar",
        crear: "Crear",
        headerColor: "Color",
        headerNombre: "Nombre",
        headerAcciones: "Acciones",
        sinEtiquetas: "Sin etiquetas",
      },
      stats: {
        titulo: "Estadísticas y ROI",
        ticketsHoy: "Tickets hoy",
        ticketsSemana: "Tickets esta semana",
        ticketesMes: "Tickets este mes",
        tiempoRespuesta: "Tiempo de respuesta promedio",
        impactoIA: "Impacto de la IA este mes",
        horasAhorradas: "{{hours}} horas ahorradas",
        equivalente: "Equivalente a {{days}} días de trabajo · {{ai}} mensajes respondidos por IA vs {{human}} por humanos",
        conversacionesPorDia: "Conversaciones por día (últimos 30 días)",
        mensajesIAvsHumano: "Mensajes: IA vs Humano",
        sinDatos: "Sin datos aún",
        tickets: "Tickets",
        fecha: "Fecha",
        ia: "IA",
        humano: "Humano",
      },
      contactStates: {
        titulo: "Estados de Contacto — Admin",
        estadosContacto: "Estados de Contacto",
        agregarEstado: "Agregar estado",
        motivosPerdida: "Motivos de Pérdida",
        agregarMotivo: "Agregar motivo",
        noHayMotivos: "No hay motivos de pérdida. Agregá uno para que aparezca al marcar un contacto como Perdido.",
        cierreAutomatico: "Cierre Automático de Tickets",
        cerrarGanado: "Cerrar ticket al marcar como Ganado",
        descCerrarGanado: "Cuando un contacto se marca como Ganado, el ticket activo se cierra automáticamente.",
        cerrarPerdido: "Cerrar ticket al marcar como Perdido",
        descCerrarPerdido: "Cuando un contacto se marca como Perdido, el ticket activo se cierra automáticamente.",
        guardarConfig: "Guardar configuración",
        sistema: "Sistema",
        desactivar: "Desactivar",
        activar: "Activar",
        subir: "Subir",
        bajar: "Bajar",
        editar: "Editar",
        eliminar: "Eliminar",
        noEliminarSistema: "No se puede eliminar un estado del sistema",
        ocultarSistema: "Estado del sistema. Podés ocultarlo pero no eliminarlo.",
        editarEstado: "Editar estado",
        nuevoEstado: "Nuevo estado",
        editarMotivo: "Editar motivo",
        nuevoMotivo: "Nuevo motivo de pérdida",
        nombre: "Nombre",
        cancelar: "Cancelar",
        guardar: "Guardar",
        nombreObligatorio: "El nombre es obligatorio",
        estadoActualizado: "Estado actualizado",
        estadoCreado: "Estado creado",
        estadoEliminado: "Estado eliminado. Los contactos asignados quedaron sin estado.",
        motivoActualizado: "Motivo actualizado",
        motivoCreado: "Motivo creado",
        motivoEliminado: "Motivo eliminado",
        configuracionGuardada: "Configuración guardada",
        confirmarEliminacion: "Confirmar eliminación",
        eliminarEstado: "¿Eliminar este estado? Los contactos con este estado quedarán sin estado asignado.",
        eliminarMotivo: "¿Eliminar este motivo de pérdida?",
      },
      pendingDashboard: {
        titulo: "Tablero de Pendientes",
        actualizar: "Actualizar",
        actualizadoAt: "Actualizado {{hora}}",
        mios: "Míos",
        vencidos: "Vencidos",
        hoy: "Hoy",
        proximos7d: "Próximos 7d",
        sinFecha: "Sin fecha",
        totalActivos: "Total activos",
        ver: "Ver",
        soloMios: "Solo míos",
        miEquipo: "Mi equipo",
        todos: "Todos",
        asesor: "Asesor",
        motivo: "Motivo",
        limpiarFiltros: "Limpiar filtros",
        sinPendientesGrupo: "Sin pendientes en este grupo",
        sinAsignar: "Sin asignar — equipo",
        asignadoA: "Asignado a: {{name}}",
        ultimaAccion: "Última acción: {{name}} · {{date}}",
        tomar: "Tomar",
        reprogramar: "Reprogramar",
        resolver: "Resolver",
        chat: "Chat",
        asignarmeEste: "Asignarme este pendiente",
        marcarResuelto: "Marcar como resuelto",
        irAlChat: "Ir al chat",
        pendienteResuelto: "Pendiente resuelto",
        pendienteReprogramado: "Pendiente reprogramado",
        pendienteAsignado: "Pendiente asignado a vos",
        reprogramarTitulo: "Reprogramar pendiente",
        cuando: "¿Cuándo?",
        fechaYHora: "Fecha y hora",
        cancelar: "Cancelar",
        guardar: "Guardar",
        sinFechaChip: "sin fecha",
        sinResponsable: "sin responsable",
        vencidoText: "vencido",
        venceText: "vence",
        hoyText: "hoy",
        proximos7dias: "Próximos 7 días",
        sinFechaGrupo: "Sin fecha",
      },
      reports: {
        titulo: "Reportes",
        desde: "Desde",
        hasta: "Hasta",
        agente: "Agente",
        todos: "Todos",
        cola: "Cola",
        todas: "Todas",
        motivoContacto: "Motivo de contacto",
        generar: "Generar",
        exportarCSV: "Exportar CSV",
        totalChats: "Total chats",
        cerrados: "Cerrados",
        enAtencion: "En atención",
        esperando: "Esperando",
        sinRespuesta: "Sin respuesta",
        respPromedio: "Resp. promedio",
        chatsPorDia: "Chats por día",
        chats: "Chats",
        fecha: "Fecha",
        estadoChats: "Estado de chats",
        sinDatos: "Sin datos",
        chatsPorAgente: "Chats por agente",
        chatsPorCola: "Chats por cola",
        pctTotal: "% del total",
        chatsPorMotivo: "Chats por motivo de contacto",
        motivo: "Motivo",
        ia: "IA",
        humano: "Humano",
        abiertos: "Abiertos",
        pendientes: "Pendientes",
        mensajesIAvsHumano: "Mensajes: IA vs Humano",
      },
      contacts: {
        title: "Contactos",
        toasts: { deleted: "¡Contacto eliminado exitosamente!" },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar",
          importTitlte: "Importar contactos",
          deleteMessage: "¿Estás seguro de que querés eliminar este contacto? Se perderán todos los chats relacionados.",
          importMessage: "¿Querés importar todos los contactos del teléfono?",
        },
        buttons: {
          import: "Importar contactos",
          add: "Agregar contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Acciones",
        },
        tabContactos: "Contactos",
        tabClientes: "Contactos",
        tabPendientes: "Pendientes",
        tabDescartados: "Descartados",
        tabTodos: "Todos",
        colNombreWA: "Nombre WhatsApp",
        colTipoCliente: "Tipo de cliente",
        colNumero: "Número",
        colEmpresa: "Empresa",
        colNotas: "Notas",
        colAtendidoPor: "Atendido por",
        colTotalChats: "Total chats",
        colUltimaActividad: "Última actividad",
        sinNombre: "Sin nombre",
        moveTo_qualified: "Contactos",
        moveTo_pending: "Pendientes",
        moveTo_disqualified: "Descartados",
        movedToast: "Contacto movido a {{tab}}",
        undoButton: "Deshacer",
        menuMoveTo_qualified: "Pasar a Contactos",
        menuMoveTo_pending: "Pasar a Pendientes",
        menuMoveTo_disqualified: "Pasar a Descartados",
        importando: "Importando contactos en segundo plano...",
        importOk: "Se importaron {{imported}} contactos. {{skipped}} ya existían.",
        importDone: "Importación completada.",
      },
      queueModal: {
        title: { add: "Agregar cola", edit: "Editar cola" },
        form: { name: "Nombre", color: "Color", greetingMessage: "Mensaje de bienvenida" },
        buttons: { okAdd: "Agregar", okEdit: "Guardar", cancel: "Cancelar" },
        signatureRule: "Regla de firma",
      },
      userModal: {
        title: { add: "Agregar usuario", edit: "Editar usuario" },
        form: { name: "Nombre", email: "Email", password: "Contraseña", profile: "Perfil", whatsapp: "Conexión predeterminada", canSeeUnassigned: "Ver chats sin asignar", allowedWhatsapps: "Conexiones permitidas", allowedWhatsappsAll: "Todas las conexiones", allowedWhatsappsHelp: "Si no seleccionás ninguna, el usuario verá los chats de todas las conexiones." },
        buttons: { okAdd: "Agregar", okEdit: "Guardar", cancel: "Cancelar" },
        success: "Usuario guardado exitosamente.",
        signatureSectionTitle: "Firma de mensajes",
        signatureEnabledLabel: "Habilitar firma personal",
        signatureNameLabel: "Nombre para firmar (opcional)",
        signatureNameHelp: "Si lo dejás vacío, se usa tu nombre normal de usuario.",
        showName: "Incluir nombre",
        showDepartment: "Incluir departamento (cola del ticket)",
        showCompany: "Incluir empresa",
        signaturePreviewLabel: "Vista previa:",
        signaturePreviewDept: "[Departamento]",
        signaturePreviewCompany: "[Empresa]",
        signaturePreviewEmpty: "(sin componentes seleccionados — equivale a no firmar)",
        signaturePreviewDisabled: "(firma desactivada)",
        signatureSanitizedWarning: "Se eliminaron caracteres especiales (* _ ~ `) de tu firma. Esos caracteres rompen el formato y no se permiten.",
        chipsVisibility: {
          title: "Estadísticas y datos del ticket",
          subtitle: "Mostrá u ocultá la información que aparece en cada ticket de la lista",
          attentionTime: {
            label: "Tiempo de respuesta (TDR)",
            tooltip: "Tiempo que el cliente lleva esperando nuestra respuesta",
          },
          clientSilence: {
            label: "Tiempo sin respuesta del cliente",
            tooltip: "Tiempo desde nuestra última respuesta sin que el cliente vuelva a escribir",
          },
          ticketAge: {
            label: "Antigüedad del ticket",
            tooltip: "Tiempo total que lleva abierto el ticket",
          },
          expiration: {
            label: "Expiración",
            tooltip: "Tickets próximos a cerrarse automáticamente",
          },
          contactState: {
            label: "Estado del contacto",
            tooltip: "Estado comercial del contacto (Nuevo, Ganado, Cliente, etc.)",
          },
          whatsappLine: {
            label: "Línea de WhatsApp",
            tooltip: "Conexión de WhatsApp por la que entró el ticket",
          },
          contactType: {
            label: "Tipo de cliente",
            tooltip: "Categoría asignada al contacto",
          },
          queue: {
            label: "Departamento",
            tooltip: "Cola o departamento asignado al ticket",
          },
          tags: {
            label: "Etiquetas",
            tooltip: "Etiquetas aplicadas al ticket",
          },
        },
      },
      chatConnectionBar: {
        windowOpen: "Ventana abierta",
        closesIn: "cierra en {{time}}",
        windowClosed: "Ventana cerrada",
      },
      messagesInput: {
        placeholderOpen: "Escribí un mensaje o presioná '/' para usar las respuestas rápidas",
        placeholderClosed: "Reabrí o aceptá este ticket para enviar un mensaje.",
        metaWindowClosedPlaceholder: "Ventana de 24hs cerrada — iniciá con una plantilla para escribirle.",
        signMessage: "Firmar",
        includeName: "Incluir nombre",
        captionPlaceholder: "Agregar un comentario...",
        cancelMedia: "Cancelar",
        sendMedia: "Enviar",
        dropFileHere: "Soltá el archivo aquí",
        lockReason: {
          company_disabled: "La firma está desactivada en la configuración de la empresa.",
          contact_forced: "Este contacto está configurado para firmar siempre.",
          contact_blocked: "Este contacto está configurado para no firmar nunca.",
          type_forced: "El tipo de cliente está configurado para firmar siempre.",
          type_blocked: "El tipo de cliente está configurado para no firmar nunca.",
          queue_forced: "La cola del ticket está configurada para firmar siempre.",
          queue_blocked: "La cola del ticket está configurada para no firmar nunca.",
        },
      },
      scheduledMessages: {
        mode_button: "Programar envío",
        queue_hint: "Mensajes en cola",
        max_reached: "Máximo 4 mensajes por envío programado",
        pick_datetime: "¿Cuándo enviar?",
        send_anyway_label: "Enviar igual aunque el contacto responda",
        badge: "Programado para {{datetime}}",
        cancelled_reply: "Envío programado cancelado: el contacto respondió",
        cancelled_manual: "Envío programado cancelado",
        cancel_action: "Cancelar mensaje programado",
        sent_ok: "Mensaje programado enviado",
        send_failed: "No se pudo enviar el mensaje programado",
        cancel: "Cancelar",
        invalid_past: "La fecha y hora deben ser futuras",
        was_scheduled: "Enviado como mensaje programado",
        sending: "Enviando…",
        trace_by: "Programado por {{name}}",
        trace_anon: "Programado",
        trace_for: "para {{datetime}}",
        event_cancelled_manual: "Envío programado cancelado por el operador",
        event_cancelled_reply: "Envío programado cancelado: el contacto respondió",
        event_cancelled_closed: "Envío programado cancelado: el ticket se cerró",
        event_cancelled_notfound: "Envío programado cancelado: el ticket ya no existe",
        event_failed: "No se pudo enviar el mensaje programado",
        event_failed_window: "No se pudo enviar: la ventana de 24 h expiró",
        event_failed_partial: "{{sent}} de {{total}} enviados — el resto no se pudo enviar",
      },
      signatureOnboarding: {
        message: "Tu empresa tiene la firma de mensajes habilitada. Configurá tu firma personal para identificarte mejor con tus clientes.",
        configure: "Configurar",
        dismiss: "Descartar",
      },
      contactModal: {
        title: { add: "Agregar contacto", edit: "Editar contacto" },
        form: {
          mainInfo: "Datos del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de WhatsApp",
          numberHelp: "Solo números con código de país. Ej: 5493513456789",
          numberOnlyDigits: "Solo se permiten números.",
          email: "Email",
          extraName: "Nombre del campo",
          extraValue: "Valor",
          lastName: "Apellido",
          whatsappName: "Nombre WhatsApp",
          company: "Empresa",
          kind: "Tipo de cliente",
          notes: "Notas",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado exitosamente.",
        statusSection: "Estado del contacto",
        moveTo_qualified: "Contactos",
        moveTo_pending: "Pendientes",
        moveTo_disqualified: "Descartados",
        movedToast: "Contacto movido a {{tab}}",
        signatureMode: "Modo de firma",
        signatureModeDefault: "Por defecto (decide el usuario o reglas de tipo)",
        signatureModeAlways: "Firmar siempre con este contacto",
        signatureModeNever: "Nunca firmar con este contacto",
      },
      contactTypeModal: {
        title: "Editar tipo de cliente",
        name: "Nombre",
        color: "Color",
        signatureRule: "Regla de firma",
        cancel: "Cancelar",
        save: "Guardar",
        savedOk: "Tipo de cliente actualizado",
        errNameRequired: "El nombre es obligatorio",
      },
      deleteMessageModal: {
        title: "¿Deseas eliminar este mensaje?",
        forEveryone: "Eliminar para todos",
        forMe: "Eliminar para mí",
        cancel: "Cancelar",
        revokeFallbackToast: "El mensaje no pudo eliminarse para todos. Se eliminó solo para vos.",
      },
      settingsExtra: {
        // feat_347 — labels de los 8 tabs de /Settings
        // feat_352 — se fue `tabIa` (el tab se fusionó en automatizaciones) y entró
        // `tabReporteEmail`. Siguen siendo 8.
        tabNegocio: "Negocio",
        tabBandeja: "Bandeja de entrada",
        tabMensajes: "Mensajes",
        tabAutomatizaciones: "Automatizaciones",
        tabReporteEmail: "Reporte por email",
        tabClasificacion: "Clasificación",
        tabIntegraciones: "Integraciones y API",
        tabPermisos: "Permisos",
        // feat_351 — tab Permisos restyleado con el patrón visual canónico
        permisosSectionTitle: "Permisos de los asesores",
        permisosSectionHelp: "Elegí qué puede hacer en los chats un asesor, es decir todo usuario que no sea administrador. Los administradores siempre tienen todos los permisos.",
        permisosDeleteChatLabel: "Permitir eliminar chats",
        permisosDeleteChatHelp: "El asesor puede eliminar un chat completo desde el menú del chat.",
        permisosDeleteChatTooltip: "Elimina el chat entero, con todos sus mensajes, para toda la empresa. No se puede deshacer.",
        permisosDeleteMessageLabel: "Permitir eliminar mensajes",
        permisosDeleteMessageHelp: "El asesor puede eliminar mensajes sueltos dentro de un chat.",
        permisosDeleteMessageTooltip: "Elimina un mensaje del historial del chat. Si lo envió la empresa y WhatsApp todavía lo permite, se ofrece además eliminarlo para el cliente.",
        moreInfoAriaLabel: "Más información",
        // feat_339 — gate de carga de la página de Ajustes
        loadingSettings: "Cargando…",
        identidadAsistente: "Identidad del Asistente",
        // feat_353 — restyle del tab Negocio con el patrón de feat_351
        negocioIdentidadHelp: "Cómo se presenta la IA y con qué datos habla de tu empresa.",
        negocioSedeLabel1: "Sede 1",
        negocioSedePh1: "Ej: Central (Av. Naciones Unidas 346)",
        negocioSedeLabel2: "Sede 2",
        negocioSedePh2: "Ej: Sucursal Norte",
        negocioHorarioHelp: "Base horaria que usan el carrito abandonado y los demás automatismos.",
        negocioAlways247Help: "La empresa se considera siempre disponible.",
        negocioFeriadosHelp: "Días en los que la empresa no atiende, aunque el horario diga que sí.",
        nombreNegocio: "Nombre del negocio",
        phNombreNegocio: "Ej: Consultorio Dental Gazzera",
        nombreAsistente: "Nombre del asistente virtual",
        phNombreAsistente: "Ej: Lucía",
        idioma: "Idioma",
        tonoAsistente: "Tono del asistente",
        tokenAPI: "Token de API",
        usarTokenDesc: "Usá este token para conectar WAIA con sistemas externos.",
        ocultarToken: "Ocultar token",
        mostrarToken: "Mostrar token",
        copiarToken: "Copiar token",
        tokenCopiado: "Token copiado",
        integracionIA: "Integración / IA",
        guardarConfig: "Guardar configuración",
        iaHabilitada: "IA habilitada",
        vendedorIA: "Vendedor IA",
        activo: "Activo",
        inactivo: "Inactivo",
        deshabilitadoAdmin: "Deshabilitado por administrador",
        automatizacionTickets: "Automatización de tickets",
        escenario1: "Escenario 1: Carrito abandonado",
        descEscenario1: "El asesor o la IA enviaron el último mensaje, pero el cliente no respondió. Se notifica a la IA via webhook para hacer seguimiento.",
        escenario2: "Escenario 2: Sin atender",
        descEscenario2: "El cliente envió el último mensaje pero el equipo no respondió. Se agrega una nota interna al ticket para alertar al asesor asignado.",
        escenario3: "Escenario 3: Ticket olvidado",
        descEscenario3: "El asesor o la IA enviaron el último mensaje, el ticket tiene un asesor asignado y lleva demasiado tiempo abierto. El ticket se cierra automáticamente con una nota interna.",
        activar: "Activar",
        umbralHoras: "Umbral de inactividad (horas)",
        rec4h: "Recomendado: 4 horas",
        rec2h: "Recomendado: 2 horas",
        rec24h: "Recomendado: 24 horas",
        configClasica: "Configuración clásica (cierre por inactividad general)",
        activarResolucion: "Activar resolución automática por inactividad",
        resolverEn: "Resolver en (horas de inactividad)",
        ticketsSinActividad: "Tickets sin actividad por este tiempo serán cerrados",
        notificarCliente: "Notificar al cliente (minutos antes del cierre)",
        sinNotificacion: "0 = sin notificación previa al cierre",
        mensajeDespedida: "Mensaje de despedida al cliente",
        phMensajeDespedida: "Hola, tu consulta fue cerrada por inactividad. Podés escribirnos cuando quieras.",
        enviarAnteCierre: "Se envía al cliente antes de cerrar el ticket",
        notificarIA: "Notificar al sistema IA al cerrar (para que tome contexto)",
        continuidadConversacion: "Continuidad de conversación",
        descContinuidad: "Define cuántos días después de cerrado un ticket puede reabrirse si el cliente vuelve a escribir. Con 0 días, la conversación nunca se fragmenta: siempre es el mismo ticket.",
        diasReapertura: "Días de reapertura",
        tdrTitle: "Semáforo de Tiempo de Respuesta (TDR)",
        tdrDesc: "Define los umbrales de alerta para el tiempo de espera del cliente. El indicador cambia de color según el tiempo transcurrido desde el último mensaje del cliente sin respuesta del equipo.",
        tdrAmarilla: "Alerta amarilla (minutos)",
        tdrAmarillaDesc: "El indicador se vuelve amarillo cuando el cliente lleva este tiempo esperando sin respuesta.",
        tdrRoja: "Alerta roja (minutos)",
        tdrRojaDesc: "El indicador se vuelve rojo cuando el cliente lleva este tiempo esperando sin respuesta.",
        tdrWarning: "⚠️ El umbral amarillo debe ser menor que el umbral rojo.",
        tiposCliente: "Tipos de Cliente",
        nombreTipo: "Nombre del tipo",
        sinTipos: "Sin tipos definidos",
        agregar: "Agregar",
        motivosContacto: "Motivos de Contacto",
        nombreMotivo: "Nombre del motivo",
        sinMotivos: "Sin motivos definidos",
        copiar: "Copiar",
        copiado: "¡Copiado!",
        urlAutomatizacion: "URL de Automatización",
        tokenAutomatizacion: "Token de Automatización",
        timeoutSegundos: "Timeout (segundos)",
        reintentos: "Reintentos",
        promptAsistente: "Prompt del Asistente",
        firmaTitle: "Firma de mensajes",
        firmaEnabledLabel: "Habilitar firma para esta empresa",
        firmaEnabledHelp: "Cuando está activo, los usuarios pueden firmar sus mensajes salientes con su nombre, departamento y/o empresa. Cada usuario configura su firma personal en su perfil.",
        firmaReglaNoneOption: "Sin regla (decide el usuario)",
        firmaReglaAlwaysOption: "Siempre firmar",
        firmaReglaNeverOption: "Nunca firmar",
        firmaReglaPreferOnOption: "Sugerir firmar (switch arranca ON)",
        firmaReglaPreferOffOption: "Sugerir no firmar (switch arranca OFF)",
        firmaQuoteLabel: "Estilo cita (quote) en la firma",
        firmaQuoteHelp: "Si está activo, la firma se envía como bloque cita de WhatsApp (verde indentado) para destacarse del mensaje.",
        cancelScheduledOnReplyLabel: "Cancelar mensajes programados si el contacto responde",
        markReadOnOpenSectionTitle: "Lectura de mensajes",
        markReadOnOpenLabel: "Marcar como leído al abrir el chat",
        markReadOnOpenHelper: "Si está activo, los mensajes se marcan como leídos en cuanto el asesor abre el chat. Si está desactivado, solo se marcan al enviar una respuesta.",
        showUserFilterSectionTitle: "Filtro por usuario en bandeja",
        showUserFilterLabel: "Mostrar filtro por usuario (solo admins)",
        showUserFilterHelper: "Permite a los admins filtrar la bandeja por uno o más asesores asignados.",
        inboxModeSectionTitle: "Modo de bandeja de entrada",
        inboxModeLabel: "Modo de bandeja de entrada",
        inboxModeHelper: "Unificado muestra EN ATENCIÓN y EN ESPERA en una sola lista ordenada por actividad.",
        inboxModeSplit: "Separado (dos sub-tabs)",
        inboxModeUnified: "Unificado (estilo WhatsApp)",
        inboxOpenCount: "En atención",
        inboxPendingCount: "En espera",
        inboxOpenTooltip: "Chats que ya tienen un asesor asignado",
        inboxPendingTooltip: "Chats esperando ser atendidos",
        inboxModeSmart: "Inteligente (huérfanos en Espera)",
        inboxSmartAttendingTooltip: "Chats en atención + derivados por la IA",
        inboxSmartWaitingTooltip: "Chats sin departamento asignado — requieren atención humana",
        inboxSortLabel: "Orden",
        inboxSortChrono: "Cronológico",
        inboxSortUrgent: "Urgentes primero",
        inboxUnansweredLabel: "Sin responder",
        inboxUnansweredTooltip: "Muestra solo los chats donde el cliente escribió y nadie respondió todavía",
        inboxUnansweredActive: "Filtrando: sin responder",
        attendingModeSectionTitle: "En atención por (indicador y bloqueo)",
        attendingModeLabel: "Modo",
        attendingModeOff: "Sin indicador",
        attendingModeVisual: "Mostrar quién atiende",
        attendingModeLock: "Mostrar y bloquear escritura ajena",
        attendingModeHelper: "\"Mostrar quién atiende\" agrega un indicador \"EN ATENCIÓN POR\" en el header y el listado cuando un ticket abierto lo lleva otro asesor. \"Bloquear escritura ajena\" además impide escribir en ese ticket. El dueño del ticket y los administradores siempre pueden escribir; los pendientes sin asignar quedan libres.",
        closedPooledSectionTitle: "Resueltos compartidos (quién puede retomarlos)",
        closedPooledLabel: "Modo",
        closedPooledOff: "Aislado (cada uno ve lo suyo)",
        closedPooledQueue: "Resueltos compartidos por cola",
        closedPooledCompany: "Resueltos compartidos en toda la empresa",
        closedPooledHelper: "Un chat resuelto sigue apareciendo en el Resueltos de quien lo resolvió. Este modo decide quién MÁS puede encontrarlo con la lupa y retomarlo: nadie (aislado), los asesores de la misma cola, o cualquier persona de la empresa. Al retomarlo pasa a EN ATENCIÓN, queda asignado a quien lo tomó y se mueve a su cola. Mientras lo atiende una persona, la IA no responde.",
        // feat_339 — desglose por modo, debajo de la intro de arriba
        closedPooledHelperOff: "Nadie más lo ve. Cada asesor encuentra únicamente los chats que resolvió él.",
        closedPooledHelperQueue: "Lo ven los asesores que comparten esa cola. Al retomarlo, pasa a la cola de quien lo tomó.",
        closedPooledHelperCompany: "Lo ve cualquier persona de la empresa, sin importar la cola. Ideal si un cliente vuelve y lo atiende quien esté libre.",
        // feat_343 — Resolver directo (cierra sin preguntar en qué quedó)
        directResolveSectionTitle: "Resolver directo",
        directResolveLabel: "Al resolver un chat, cerrarlo directo — sin preguntar en qué quedó",
        directResolveHelper: "Con la llave apagada, al tocar Resolver se pregunta si el contacto se ganó o se perdió. Con la llave encendida, Resolver cierra el chat de una y el estado del contacto queda como está.",
        outboundTypingSectionTitle: "Indicador \"escribiendo...\"",
        outboundTypingLabel: "Mostrar \"escribiendo...\" / \"grabando audio...\" al contacto",
        outboundTypingHelp: "Cuando un asesor escribe o graba un audio, el contacto lo ve en su teléfono (como WhatsApp). Solo conexiones compatibles; Meta solo \"escribiendo\" y requiere un mensaje reciente del contacto.",
        outboundTypingAiLabel: "Mostrar \"escribiendo...\" cuando responde la IA",
        outboundTypingAiHelp: "Mientras la inteligencia artificial genera una respuesta, el contacto ve \"escribiendo...\" en su teléfono. Útil para que la espera se sienta natural.",
        autoReplyMediaSectionTitle: "Respuesta automática a media",
        autoReplyMediaEnabledLabel: "Responder con una disculpa cuando llegan audios, videos, imágenes o documentos",
        autoReplyMediaEnabledHelp: "Cuando está activo, la IA no procesa la media y se envía un único mensaje de cortesía tras un breve debounce.",
        autoReplyMediaScopeLabel: "Cuándo responder",
        autoReplyMediaScopeAiOnly: "Solo cuando la IA debería responder",
        autoReplyMediaScopeAlways: "Siempre (incluso si el ticket lo atiende un humano)",
        autoReplyMediaTypesLabel: "Comportamiento por tipo de media",
        autoReplyMediaTypeAudio: "Audios (voz y adjuntos)",
        autoReplyMediaTypeVideo: "Videos",
        autoReplyMediaTypeImage: "Imágenes",
        autoReplyMediaTypeDocument: "Documentos",
        autoReplyMediaTextAudio: "Texto para audios",
        autoReplyMediaTextVideo: "Texto para videos",
        autoReplyMediaTextImage: "Texto para imágenes",
        autoReplyMediaTextDocument: "Texto para documentos",
        autoReplyMediaTypeSticker: "Stickers",
        autoReplyMediaTypeReaction: "Reacciones (emojis y 👍)",
        autoReplyMediaTextSticker: "Texto para stickers",
        autoReplyMediaTextReaction: "Texto para reacciones",
        autoReplyMediaActionLabel: "Comportamiento",
        autoReplyMediaActionAi: "Pasar a IA",
        autoReplyMediaActionIgnore: "Ignorar",
        autoReplyMediaActionReply: "Responder con texto",
        autoReplyMediaReactionHelp: "Las reacciones (👍 ❤️ etc.) se pasan a la IA como texto. La IA las interpreta como confirmaciones o respuestas.",
        autoReplyMediaTextGeneric: "Texto genérico (cuando llegan varios tipos juntos)",
        autoReplyMediaTextPlaceholder: "Si lo dejás vacío, se usa el texto por defecto en el idioma de la empresa.",
        autoReplyMediaTimeoutLabel: "Debounce (segundos)",
        autoReplyMediaTimeoutHelp: "Tiempo de espera tras el último audio/video/imagen/doc antes de enviar la disculpa. Sugerido: 60.",
        emailReportSectionTitle: "📧 Reporte por email",
        emailReportSectionDesc: "Cuando una cola queda sin respuesta por el tiempo configurado, el sistema envía un mail de reporte al destinatario configurado.",
        emailReportQueues: "Colas disparadoras",
        emailReportQueuesHelp: "El reporte se envía cuando un ticket de estas colas lleva sin respuesta el tiempo configurado.",
        emailReportRecipients: "Destinatarios del reporte",
        emailReportRecipientsHelp: "Separar con comas. Ej: admin@empresa.com, soporte@empresa.com",
        emailReportTimeoutHours: "Horas de inactividad para enviar reporte",
        emailReportTimeoutHelp: "Tiempo sin respuesta del cliente antes de enviar el reporte.",
        emailReportSubjectTemplate: "Asunto del email",
        emailReportSubjectPlaceholder: "{wlName} - Reporte de encuestado - {contactName}",
        emailReportHtmlTemplate: "Plantilla HTML del email",
        emailReportHtmlHelp: "Podés editar la plantilla. Se precarga la plantilla actual del sistema.",
        emailReportVarsTitle: "Variables disponibles en asunto y plantilla",
        emailReportVarsDesc: "{wlName} marca blanca · {companyName} empresa · {contactName} nombre contacto · {contactPhone} teléfono · {queueName} cola · {userName} asesor · {ticketId} · {closeReason} motivo · {aiSummary} resumen IA · {ticketLink} link · {closedAt} fecha · {wlLogoUrl} logo",
        emailReportTestLabel: "Email para enviar prueba",
        emailReportTestBtn: "Enviar prueba",
        emailReportTestSending: "Enviando...",
        emailReportTestSuccess: "✓ Email de prueba enviado a {email}",
        emailReportTestError: "✗ Error: {error}",
        emailReportSuperadminAllowed: "Permitir reportes por email",
        emailReportSuperadminAllowedHelp: "Habilita la sección de configuración de reportes por email para el admin de la empresa.",
      },
      headerMetrics: {
        resueltos: "Chats cerrados hoy por tu equipo",
        atencionEspera: "Chats en atención activa / esperando respuesta ahora",
        tdr1ra: "Tiempo promedio desde que el cliente escribe hasta la primera respuesta del asesor hoy",
        tdrResp: "Tiempo promedio de respuesta por mensaje en los últimos 30 días",
      },
      appointmentsSettings: {
        titulo: "Configuración de Citas",
        empresa: "Empresa",
        general: "General",
        activarModulo: "Activar módulo de citas",
        contactarAdmin: "Para activar o desactivar el módulo de citas, contactá al administrador del sistema.",
        canalWhatsapp: "Canal WhatsApp para avisos",
        principalAuto: "Principal (automático)",
        tiposCita: "Tipos de cita",
        tiposCitaDesc: "El asesor elige el tipo al agendar. Sé específico.",
        cargarEjemplos: "Cargar ejemplos",
        nuevoTipo: "Nuevo tipo",
        agregar: "Agregar",
        avisosAutomaticos: "Avisos automáticos",
        aviso1: "Aviso 1 — 24 horas antes",
        aviso2: "Aviso 2 — A primera hora del día de la cita",
        aviso3: "Aviso 3 — Poco antes de la cita",
        textoMensaje: "Texto del mensaje",
        minutosAntes: "Minutos antes",
        horaAviso: "Hora del aviso",
        notaAviso2: "Nota: Si la cita es a primera hora y el aviso 3 queda dentro de los 30 minutos siguientes, este aviso se omite automáticamente.",
        guardarConfig: "Guardar configuración",
        errorGuardar: "Error al guardar",
        configGuardada: "Configuración guardada",
      },
      bulkSend: {
        steps: { upload: "Archivo", preview: "Vista previa", template: "Plantilla", options: "Opciones", confirm: "Confirmar" },
        history: {
          title: "Historial de envíos",
          viewHistory: "Ver historial de envíos",
          backToWizard: "Volver al asistente",
          backToList: "Volver al historial",
          columnDate: "Fecha", columnFile: "Archivo", columnStatus: "Estado", columnProgress: "Progreso",
          loadMore: "Cargar más", empty: "Todavía no se hizo ningún envío.",
        },
        back: "Atrás",
        next: "Siguiente",
        upload: {
          hint: "Arrastrá o hacé clic para subir tu archivo Excel (.xlsx)",
          choose: "Elegir archivo",
          selected: "Archivo: {{name}}",
          readError: "No se pudo leer el archivo",
        },
        preview: {
          total: "Filas totales", valid: "Válidas", skipped: "Descartadas",
          skFilter: "Por filtro", skPhone: "Teléfono inválido", skDup: "Duplicadas",
          sample: "Muestra (primeras filas normalizadas)",
          colName: "Nombre", colPhone: "Teléfono", colVars: "Variables",
          noValid: "No hay filas válidas para enviar. Revisá el archivo y los filtros del perfil.",
        },
        template: {
          connLabel: "Conexión de Meta", noConn: "No hay conexiones de Meta conectadas en esta empresa.",
          tplLabel: "Plantilla aprobada", noTpl: "Esta conexión no tiene plantillas aprobadas.",
          lastUsedHint: "última usada",
          varsTitle: "Vista previa del mensaje (con la primera fila)",
          varMismatch: "La plantilla tiene {{tpl}} variables pero el perfil arma {{prof}}. Elegí una plantilla con la misma cantidad.",
        },
        options: {
          throttle: "Segundos entre envíos", throttleHelp: "Pausa entre cada mensaje (1 a 60 segundos).",
          contextModeLabel: "Modo de contexto",
          contextModeNormal: "Normal",
          contextModeTurnosia: "TurnosIA (invitación a agendar)",
          contextModeHint: "Cómo se le avisa al asistente de qué se trata este envío. En modo TurnosIA, además de enviar la plantilla, se le indica al asistente que el contacto fue invitado a agendar un turno.",
          optIn: "Confirmo que los destinatarios dieron su consentimiento para recibir mensajes.",
          overwriteTitle: "Atención: este envío pisa datos existentes",
          overwrite: "Si algún destinatario ya existe como contacto en WAIA, este envío va a pisar sus notas y a reasignarle el asistente, la cola y el estado definidos en este perfil. Confirmá que este comportamiento es el deseado.",
        },
        confirm: {
          title: "Revisá antes de enviar", file: "Archivo", validRows: "Filas a enviar",
          conn: "Conexión", tpl: "Plantilla", throttle: "Pausa entre envíos",
          warnBrief: "Recordá: los contactos existentes se pisan (notas, asistente, cola, estado).",
          send: "Confirmar y enviar", sentOk: "Envío iniciado",
        },
        dedupe: {
          msg: "Ya se subió un archivo idéntico el {{date}}. ¿Enviar igual?",
          confirm: "Enviar igual", cancel: "Cancelar",
        },
        result: {
          title: "Resultado del envío", pending: "En cola", processing: "Procesando",
          completed: "Completado", pausedMeta: "Pausado (Meta)", failed: "Fallido", cancelled: "Cancelado",
          sent: "Enviados", failedC: "Fallidos", skipped: "Descartados", total: "Total",
          pausedExplain: "El envío se pausó porque Meta rechazó 5 mensajes seguidos. Revisá la conexión y reintentá los fallidos.",
          retry: "Reintentar fallidos", retrying: "Reintentando...", retryDone: "{{n}} filas puestas en cola de nuevo",
          newImport: "Nuevo envío", rowsTitle: "Detalle por fila", colStatus: "Estado", colDetail: "Detalle",
          rowStatus: {
            pending: "En cola", sent: "Enviado", failed: "Fallido",
            skipped_filter: "Descartada (filtro)", skipped_invalid_phone: "Teléfono inválido",
            skipped_dup_in_batch: "Duplicada", skipped_optout: "Sin consentimiento",
          },
        },
      },
      cargaDeDatos: {
        menuTitle: "Carga de Datos",
        empty: "No hay formularios configurados",
        loading: "Cargando...",
        errorLoading: "Error al cargar el formulario",
      },
      metaTemplates: {
        drawerTitle: "Plantillas Meta",
        tabMine: "Mis plantillas",
        tabSend: "Enviar plantilla",
        syncButton: "Sincronizar",
        syncSuccess: "{{count}} plantillas sincronizadas",
        syncError: "Error al sincronizar plantillas",
        newButton: "Nueva plantilla",
        noTemplates: "No hay plantillas. Hacé clic en Sincronizar para cargar desde Meta.",
        deleteConfirm: "¿Eliminar esta plantilla en Meta y en el sistema?",
        deleteSuccess: "Plantilla eliminada",
        deleteError: "Error al eliminar la plantilla",
        createSuccess: "Plantilla enviada a Meta para aprobación",
        createError: "Error al crear la plantilla",
        sendSuccess: "Plantilla enviada",
        sendError: "Error al enviar la plantilla",
        form: {
          name: "Nombre (snake_case, sin espacios)",
          category: "Categoría",
          language: "Idioma",
          headerType: "Header (opcional)",
          headerFormat: "Tipo de encabezado",
          headerFormats: {
            NONE: "Ninguno",
            TEXT: "Texto",
            IMAGE: "Imagen",
            DOCUMENT: "Documento",
            VIDEO: "Video",
          },
          headerSample: "Archivo de muestra",
          headerSampleNotice:
            "Este archivo es solo un ejemplo para que Meta apruebe la plantilla. En cada envío vas a elegir el archivo real (la factura, el presupuesto, etc.).",
          headerSampleChoose: "Elegir archivo de muestra",
          pendingNotice:
            "La plantilla queda pendiente hasta que Meta la apruebe. La aprobación puede demorar; el estado se actualiza al sincronizar.",
          headerText: "Texto del header",
          body: "Cuerpo del mensaje",
          bodyHint: "Usá {{1}}, {{2}}, etc. para variables",
          examplesHint: "Meta exige un ejemplo por cada variable para aprobar la plantilla.",
          exampleFor: "Ejemplo para {{var}}",
          varsNotSequential: "Las variables deben ser correlativas desde {{1}} (sin saltos).",
          footer: "Footer (opcional)",
          submit: "Crear plantilla",
          cancel: "Cancelar",
        },
        suggested: {
          useButton: "Usar plantilla sugerida",
          listTitle: "Plantillas sugeridas (listas para aprobar)",
          approvalNotice:
            "Estas plantillas pasan por aprobación de Meta, pero al estar pre-validadas suelen aprobarse rápido. Podés editar el texto y los ejemplos antes de crearla.",
          names: {
            retomar_conversacion: "Retomar conversación",
            recordatorio_cita: "Recordatorio de cita",
            seguimiento_general: "Seguimiento",
            aviso_disponible: "Aviso de novedades",
            reapertura_24h: "Reapertura tras 24hs",
          },
        },
        categories: {
          MARKETING: "Marketing",
          UTILITY: "Utilidad",
          AUTHENTICATION: "Autenticación",
        },
        languages: {
          es: "Español",
          en: "Inglés",
          pt: "Portugués",
          it: "Italiano",
        },
        status: {
          APPROVED: "Aprobada",
          PENDING: "Pendiente",
          REJECTED: "Rechazada",
          PAUSED: "Pausada",
          DELETED: "Eliminada",
          DISABLED: "Deshabilitada",
          IN_APPEAL: "En apelación",
          REINSTATED: "Restaurada",
          LIMIT_EXCEEDED: "Límite excedido",
          PENDING_DELETION: "Pendiente de eliminación",
        },
        sendForm: {
          attachment: "Adjunto",
          attachmentChoose: "Elegir archivo",
          attachmentHint: {
            DOCUMENT: "Esta plantilla envía un documento: elegí el archivo real (PDF, Word o Excel).",
            IMAGE: "Esta plantilla envía una imagen: elegí el archivo real.",
            VIDEO: "Esta plantilla envía un video: elegí el archivo real.",
          },
          selectTemplate: "Seleccioná una plantilla aprobada",
          toNumber: "Número destino (con código de país)",
          variables: "Variable {{index}}",
          submit: "Enviar",
          noApproved: "No hay plantillas aprobadas",
        },
        windowBanner: {
          message: "⏰ Ventana de 24hs cerrada. El contacto debe escribir primero, o iniciá la conversación con una plantilla.",
          sendTemplate: "Enviar plantilla",
        },
        inline: {
          selectLabel: "Elegí una plantilla",
          noApproved: "No tenés plantillas aprobadas todavía. Creá una para iniciar la conversación.",
          createButton: "Crear plantilla",
          previewLabel: "Vista previa",
          sendButton: "Enviar plantilla",
          sentTitle: "Plantilla enviada",
          sendAnother: "Enviar otra",
        },
      },
      embeddedSignup: {
        title: "Conectar con WhatsApp Business",
        connectButton: "Conectar con Meta",
        manualButton: "Ingresar datos manualmente",
        connecting: "Conectando...",
        success: "Conexión creada exitosamente",
        error: "Error al conectar con Meta",
        connectionName: "Nombre de la conexión",
        emptyMetaError: "Completá la conexión con Meta (botón Conectar con Meta) o ingresá los datos manualmente. No se puede crear una conexión Meta vacía.",
        cancelled: "Conexión con Meta cancelada.",
      },
      batchSelection: {
        exit: "Salir de selección",
        count: "{{count}} seleccionados",
        markRead: "Marcar como leído",
        resolve: "Resolver",
        transfer: "Transferir",
        delete: "Eliminar",
        restore: "Restaurar",
        hardDelete: "Eliminar definitivo",
        more: "Más acciones",
        selectAllVisible: "Seleccionar todos los visibles",
        toast: {
          markReadOk: "{{count}} chats marcados como leídos",
          markReadPartial: "Marcados como leídos {{processed}} de {{total}} ({{skipped}} omitidos)",
          resolveOk: "{{count}} chats resueltos",
          resolvePartial: "Resueltos {{processed}} de {{total}} ({{skipped}} omitidos)",
          transferOk: "{{count}} chats transferidos",
          transferPartial: "Transferidos {{processed}} de {{total}} ({{skipped}} omitidos)",
          restoreOk: "{{count}} chats restaurados",
          restorePartial: "Restaurados {{processed}} de {{total}} ({{skipped}} omitidos)",
          deletedWithUndo: "{{count}} chats enviados a Eliminados",
          undo: "Deshacer",
          undoOk: "Restauración aplicada",
          hardDeleteOk: "{{count}} chats eliminados permanentemente",
          hardDeletePartial: "Eliminados definitivamente {{processed}} de {{total}} ({{skipped}} omitidos)",
        },
      },
      resolveTicketDialog: {
        title: "¿En qué quedó esta conversación?",
        batchCount: "Vas a resolver {{count}} chats.",
        won: "Ganado",
        lost: "Perdido",
        noChange: "Sin cambio — resolver igual",
      },
      batchTransferDialog: {
        title: "Transferir chats",
        subtitle: "Vas a transferir {{count}} chats a un departamento.",
        queueLabel: "Departamento destino",
        queuePlaceholder: "Seleccionar departamento...",
        cancel: "Cancelar",
        confirm: "Transferir",
      },
      batchDeleteDialog: {
        title: "Eliminar chats",
        body: "Vas a eliminar {{count}} chats. Podés restaurarlos desde Eliminados.",
        cancel: "Cancelar",
        confirm: "Eliminar",
      },
      batchHardDeleteDialog: {
        title: "Eliminar definitivamente",
        body: "Esto eliminará {{count}} chats de forma permanente. No se puede deshacer.",
        bodySingle: "Esto eliminará este chat de forma permanente. No se puede deshacer.",
        cancel: "Cancelar",
        confirm: "Eliminar definitivo",
      },
      quotedMessage: {
        sticker: "Sticker",
        image: "Imagen",
        video: "Video",
        audio: "Mensaje de voz",
        document: "Documento",
        vcard: "Contacto",
        location: "Ubicación",
        attachment: "Adjunto",
      },
      mediaPlaceholder: {
        sticker: "Sticker",
        image: "Imagen",
        video: "Video",
        audio: "Mensaje de voz",
        document: "Documento",
        attachment: "Adjunto",
      },
      documentPreview: {
        download: "Descargar",
        openInNew: "Abrir en pestaña nueva",
        previewFailed: "No se pudo cargar la vista previa",
      },
      ticketPresence: {
        composing: "Escribiendo...",
        recording: "Grabando audio...",
        composingNamed: "{{name}} está escribiendo...",
        recordingNamed: "{{name}} está grabando audio...",
        composingSomeone: "Alguien está escribiendo...",
        recordingSomeone: "Alguien está grabando audio...",
      },
      ticketAttending: {
        header: "En atención por {{name}}",
        // feat_340: sin uso — el zócalo ahora muestra solo el primer nombre del asesor.
        chip: "Atiende {{name}}",
        locked: "En atención por {{name}} — no podés escribir",
        someone: "otro asesor",
      },
      cartAbandonedSchedule: {
        modeLabel: "¿Cuándo enviar el aviso de carrito abandonado?",
        always: "Siempre (sin restricción de horario)",
        businessHours: "Solo en horario comercial de la empresa",
        custom: "Horario personalizado para carritos",
        helperAlways: "El aviso se envía en cualquier momento en que se detecte inactividad.",
        helperBusinessHours: "Si la empresa está fuera de horario al detectar el abandono, el aviso se difiere automáticamente a la próxima corrida dentro del horario comercial.",
        helperCustom: "Definí un horario propio para los avisos de carrito abandonado, independiente del horario comercial.",
        customScheduleLabel: "Horario personalizado para avisos de carrito abandonado",
        warningNoBusinessHours: "⚠ No tenés horario comercial configurado. El aviso de carrito abandonado no se enviará hasta que lo configures en la sección Horario comercial.",
        goToBusinessHours: "Ir a Horario comercial",
      },
      holidays: {
        title: "Feriados",
        nationals: "Feriados nacionales",
        nationalsHelp: "Activá el interruptor si tu empresa trabaja ese día feriado.",
        customs: "Feriados propios",
        noCustoms: "No hay feriados propios cargados.",
        works: "Trabajamos",
        closed: "Cerrado",
        recurring: "todos los años",
        addCustom: "Agregar feriado propio",
        confirmDelete: "¿Eliminar este feriado?",
        dateLabel: "Fecha",
        nameLabel: "Nombre",
        recurringLabel: "Se repite todos los años",
        recurringHelp: "",
        cancel: "Cancelar",
        save: "Guardar",
        saveOk: "Feriado guardado",
      },
      weeklySchedule: {
        addRange: "Agregar franja",
        removeRange: "Quitar franja",
        to: "a",
        days: {
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sábado",
          sunday: "Domingo",
        },
      },
      emailReportTimerMode: {
        label: "¿Desde cuándo contar el tiempo para el reporte?",
        updatedAt: "Desde el último mensaje enviado o recibido",
        updatedAtHelp: "El contador se reinicia cada vez que hay un mensaje nuevo en el ticket, incluyendo respuestas automáticas de la IA.",
        createdAt: "Desde el inicio de la conversación (T0)",
        createdAtHelp: "El contador no se reinicia con actividad automática. El email llega siempre a las {{hours}}h del primer mensaje, sin importar si la IA intentó recuperar al cliente.",
      },
      metaErrorCodes: {
        "-100": "No enviado: los envíos de esta conexión estaban pausados.",
        tooltipPrefix: "No se pudo entregar",
        131042: "Falta método de pago en Meta (Centro de Facturación).",
        131047: "Ventana de 24hs cerrada — se requiere una plantilla aprobada.",
        131026: "El número no tiene WhatsApp o no se pudo entregar el mensaje.",
        131051: "Tipo de mensaje no soportado por Meta.",
        132000: "La plantilla no coincide con las variables enviadas.",
        132001: "La plantilla no existe o fue eliminada.",
        132005: "La plantilla está pausada por Meta.",
        132007: "La plantilla fue deshabilitada por Meta.",
        132012: "Formato de variable de plantilla inválido.",
        133010: "El número no está registrado en WhatsApp Cloud API.",
        default: "Error de entrega de Meta (código {{code}}).",
        default_unknown: "Error de entrega de Meta.",
      },
      // feat_299 — "Ver como usuario". Namespace propio: NO reusar la clave
      // `impersonate` (panel superadmin), es otra cosa.
      viewAs: {
        menuLabel: "Ver como usuario",
        modalTitle: "Ver como usuario",
        searchPlaceholder: "Buscar usuario...",
        cancel: "Cancelar",
        noUsers: "No hay usuarios disponibles",
        banner: "Verás como {{name}}",
        exit: "Salir",
        activated: "Ahora ves como {{name}}",
      },
      // feat_316 — preferencias de notificación per-user
      notificationPrefs: {
        title: "Notificaciones",
        active: "Activadas",
        mutedPermanent: "Silenciadas",
        snoozedUntil: "Silenciadas hasta las {{time}}",
        snoozeFor: "Silenciar por:",
        untilOpening: "Hasta que abramos",
        mutePermanent: "Silenciar hasta que la reactive",
        sound: "Sonido",
        browser: "Notificación del navegador",
        browserBlocked: "El navegador bloqueó las notificaciones. Habilitalas desde el candado de la barra de direcciones.",
        browserDenied: "No se concedió el permiso. Podés habilitarlo desde el candado de la barra de direcciones.",
        badgeNote: "Silenciar afecta el sonido y el aviso del navegador. El contador y la lista de chats siguen actualizándose.",
      },
      contactPriority: {
        label: "Prioridad de notificación",
        normal: "Normal",
        priority: "Prioritario (siempre notifica)",
        muted: "Silenciado (nunca notifica)",
        help: "\"Prioritario\" notifica aunque tengas las notificaciones silenciadas. \"Silenciado\" no notifica nunca.",
      },
      // feat_333 — modo WAIAenvios (etiqueta del switch en el panel superadmin)
      waiaEnvios: {
        switchLabel: "WAIAenvios — solo envíos por plantilla",
        switchHelp: "Deja el panel con Conexiones y Carga de Datos únicamente. El cliente responde desde su teléfono.",
      },
      // Boundary de módulo (feat_364). Si TurnosIA falla, falla SOLO TurnosIA.
      errorBoundary: {
        routeTitle: "Esta pantalla no se pudo mostrar",
        routeHelp: "Probá con otra sección del menú o recargá la página.",
        moduleTitle: "Esta sección no está disponible en este momento",
        moduleHelp: "El resto de WAIA sigue funcionando con normalidad. Si vuelve a pasar, avisale al soporte.",
        appTitle: "Algo falló",
        appHelp: "Recargá la página para continuar.",
        inline: "No se pudo mostrar esta parte.",
        retry: "Reintentar",
        reload: "Recargar la página",
      },
    },
  },
};

export { messages };
